import * as React from 'react'
import ChatModule from './ChatScreen.module.scss'
import ChatModuleReadOnly from './ChatScreenReadOnly.module.scss'
import { useState, useEffect, useRef, useMemo } from 'react'
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage'
import { writeBatch, collection, getDocs, doc, setDoc, query, orderBy, getDoc, updateDoc } from 'firebase/firestore'
import ChatBubble from '../../components/Bubble/ChatBubble'
import ChatBubbleForSystem from '../../components/Bubble/ChatBubbleForSystem'
import { auth, db, functions, storage } from '../../firebase'
import { useAuthState } from 'react-firebase-hooks/auth'
import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import IconButton from '@mui/material/IconButton'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import CancelIcon from '@mui/icons-material/Cancel'
import FormControl from '@mui/joy/FormControl'
import Textarea from '@mui/joy/Textarea'
import SendIcon from '@mui/icons-material/Send'
import StopCircleIcon from '@mui/icons-material/StopCircle'
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice'
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition'
import { Bars } from 'react-loader-spinner'
import VolumeOffIcon from '@mui/icons-material/VolumeOff'
import VolumeUpIcon from '@mui/icons-material/VolumeUp'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight'
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft'

import { ocr } from '../../utils/ocr'
import {
  getGptMessage,
  getAzureGptMessage,
  getGptImage,
  getGptStreamingMessageReaderAndDecoder,
  tokenCounter
} from '../../utils/gpt'
import { getUserDataFromMingaku, updateUserData } from '../../utils/getUserDataFromMingaku'
import { getClaudeStreamingMessageReaderAndDecoder } from '../../utils/claude'
import { getAmazonBedrockStreamingMessageReaderAndDecoder } from '../../utils/amazonBedrock'
import { getVertexAIGemeniStreamingMessageReaderAndDecoder } from '../../utils/vertexAI'
import { getAzureAIStreamingMessageReaderAndDecoder } from '../../utils/azureAI'
import { _responseOptions, _inserted_default_target_student_info } from '../../localConstant'
import { getAudioUrl, getAudioUrlFromOpenAi } from '../../utils/tts'
import ai from '../../assets/ai.png'
import ai2 from '../../assets/ai2.png'
import { _language_list_v2, _gpt_model, _fields_of_user_data_in_mypage } from '../../localConstant'
import { useLocation, useNavigate } from 'react-router-dom'
import { httpsCallable } from 'firebase/functions'
import { useSearchParams } from 'react-router-dom'
import Avator from '../Bubble/Avator'
import MenuIcon from '../MenuIcon/MenuIcon'
import LoadingGrid from '../LoadingGrid/LoadingGrid'
import { getMatchingLanguage } from '../../utils/getMachingLanguage'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import { styled } from '@mui/material/styles'
import { useUserDataContext } from '../../context/AuthContext'
import { ThreeDots } from 'react-loader-spinner'
import { Bubble } from 'react-chartjs-2'
import dayjs from 'dayjs'
import { handleErrorDetail } from '../../utils/handleError'
import TextSnippetIcon from '@mui/icons-material/TextSnippet'
import * as XLSX from 'xlsx'
import { handleExcelFiles } from '../../utils/excel'
import { v4 as uuid } from 'uuid'
import { useGetTranslatedValue } from '../../lang/lang'

function ChatScreen(props) {
  const {
    conversation,
    conversationType,
    startButton,
    readOnly,
    displayFooter,
    chatScreenWidth,
    userInputWidth,
    chatScreenBottom,
    chatScreenHeight,
    chatScreenHeightWithTextArea,
    chatScreenHeightWithTextAreaAndFooter,
    onStartChange,
    submitterUserId,
    customGuide
  } = props
  const {
    conversationId,
    replacedMessage,
    userInputValue,
    model,
    mode,
    defaultMute,
    autoSending,
    temperature,
    speakingRate,
    promptDocRefPath,
    userId,
    largeIcon,
    displayInputContents,
    useAssistantApi,
    assistantId,
    threadId,
    language
  } = conversation

  const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 150,
      marginRight: -50,
      zIndex: 0
    }
  })
  const translate = useGetTranslatedValue()
  const _language = language
  const [_useAssistantApi, _setUseAssistantApi] = useState(useAssistantApi)
  const styles = readOnly === true ? ChatModuleReadOnly : ChatModule
  const determineStyle = () => {
    if (readOnly === true) {
      return { width: chatScreenWidth, height: `${chatScreenHeight}px` }
    } else if ((readOnly === false) & (displayFooter === true)) {
      return { width: chatScreenWidth, height: `${chatScreenHeightWithTextAreaAndFooter + 6}px` }
    } else if ((readOnly === false) & ((displayFooter === false) & (showheader !== 'false'))) {
      return { width: chatScreenWidth, height: `${chatScreenHeightWithTextArea}px` }
    } else if ((readOnly === false) & ((displayFooter === false) & (showheader === 'false'))) {
      return { width: chatScreenWidth, height: `${chatScreenHeightWithTextArea}px` }
    }
  }
  const determineHalfStyle = () => {
    if (readOnly === true) {
      return { width: chatScreenWidth, height: `${chatScreenHeight / 2 - 8}px` }
    } else if ((readOnly === false) & (displayFooter === true)) {
      return { width: chatScreenWidth, height: `${chatScreenHeightWithTextAreaAndFooter / 2 + 4}px` }
    } else if ((readOnly === false) & ((displayFooter === false) & (showheader !== 'false'))) {
      return { width: chatScreenWidth, height: `${chatScreenHeightWithTextArea / 2}px` }
    } else if ((readOnly === false) & ((displayFooter === false) & (showheader === 'false'))) {
      return { width: chatScreenWidth, height: `${chatScreenHeightWithTextArea / 2}px` }
    }
  }

  const currentPath = window.location.pathname
  const { state } = useLocation()

  const [searchParams] = useSearchParams()
  const startover = searchParams.get('startover')
  const showheader = searchParams.get('showheader')
  const submittionBox = searchParams.get('submittion_box')
  const schoolId = searchParams.get('school_id')
  const navigate = useNavigate()
  const [isStreaming, setIsStreaming] = useState(true)
  const audio = useRef(null)
  const [newConversationId, setNewConversationId] = useState(conversationId ? conversationId : '')
  const [_audio, _setAudio] = useState(null)
  const [previousChatInput, setPreviousChatInput] = useState('')
  const sendActiveClassName = 'send-active'
  const text2imageLabelClassName = 'text2imageLabel'
  const [user] = useAuthState(auth)
  const userData = useUserDataContext()
  const { role = '' } = userData
  const [isAdmin, setIsAdmin] = useState(role === 'admin')
  const [isTutor, setIsTutor] = useState(role === 'tutor')
  const [isStudent, setIsStudent] = useState(role === 'student')
  const { transcript, interimTranscript, finalTranscript, resetTranscript } = useSpeechRecognition() // ref: https://www.loginradius.com/blog/engineering/quick-look-at-react-speech-recognition/
  const isFirstRender = useRef(false)
  const [islistening, setIsListening] = useState(false)
  const [maxCharacters, setMaxCharacters] = useState(0)
  const [characterLimit, setCharacterLimit] = useState(false)
  const [maxCharactersPerMonth, setMaxCharactersPerMonth] = useState(0)
  const [characterLimitPerMonth, setCharacterLimitPerMonth] = useState(false)
  const [_start, _setStart] = useState(false)
  const [_startButton, _setStartButton] = useState(state && state.startButton ? state.startButton : startButton)
  const [avatorImages, setAvatorImages] = useState([ai, ai2])
  const [selectedLanguage, setSelectedLanguage] = useState(_language ? _language : JSON.stringify(_language_list_v2[0]))
  const [disableSpeaker, setDisableSpeaker] = useState(false)
  const [promptData, setPromptData] = useState()
  const [isMute, setIsMute] = useState(defaultMute)
  const [isLargeIcon, setIsLargeIcon] = useState(largeIcon)
  const [responseOptions, setResponseOptions] = useState(_responseOptions)
  const [chatInput, setChatInput] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isBubbleLoading, setIsBubbleLoading] = useState(false)
  const [chatData, setChatData] = useState([])
  const [isActiveAvator, setIsActiveAvator] = useState(0)
  const [isModalOpen, setModalOpen] = useState(false)
  const [isModalOpenForSubmission, setIsModalOpenForSubmission] = useState(false)
  const [generatingImage, setGeneratingImage] = useState(false)
  const [initialPromptRef, setInitialPromptRef] = useState('')
  const [sentenceWordReplacementList, setSentenceWordReplacementList] = useState([])
  const [isSendingCountLimit, setIsSendingCountLimitSet] = useState(false)
  const [maximumSendingCountLimit, setMaximumSendingCountLimit] = useState(0)
  const [isPastMessageLimitCountSet, setIsPastMessageLimitCountSet] = useState(false)
  const [maximumPastMessageLimitCount, setMaximumPastMessageLimitCount] = useState(0)
  const [file, setFile] = useState(null)
  const [previewUrl, setPreviewUrl] = useState(null) // 画像プレビューURLの状態
  const [files, setFiles] = useState({ imageFiles: [], documentFiles: [] })
  const [hoveredDocumentFileIndex, setHoveredDocumentFileIndex] = useState(-1)
  const [previewUrls, setPreviewUrls] = useState([])
  const [hoveredPreviewIndexNumber, setHoveredPreviewIndexNumber] = useState(-1)
  const fileInputRef = useRef(null)
  const [isGenerating, setIsGenerating] = useState(false) // LLMが生成中かどうかの状態
  const [isFactCheckRunning, setIsFactCheckRunning] = useState(false)
  const [factCheckRunningIndex, setFactCheckRunningIndex] = useState(null)
  const file_size_limit = 3670016
  const SUPPORTED_EXTENSIONS = ['xls', 'xlsx']

  const isImage = (file) => {
    if (!file) return false
    if (!file.type) return false
    return file.type.startsWith('image/')
  }

  const isDocFile = (file) => {
    // 現状、DocファイルはExcelのみサポートするものとする
    if (!file) return false
    if (file.type) {
      const excelMimeTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel'
      ]
      return excelMimeTypes.includes(file.type)
    }
    if (file.name) {
      // MIMEタイプが空なるブラウザがあるので拡張子バリデーションを設ける
      const fileExtension = file.name.split('.').pop().toLowerCase()
      return SUPPORTED_EXTENSIONS.includes(fileExtension)
    }
    return false
  }

  const setNewFiles = (files) => {
    if (!files || !files.length) return
    setFiles((prevFiles) => {
      const _files = { ...prevFiles }
      files.forEach((file) => {
        if (isImage(file)) {
          _files.imageFiles = [..._files.imageFiles, file]
        } else if (isDocFile(file)) {
          _files.documentFiles = [..._files.documentFiles, file]
        }
      })
      return _files
    })
  }

  const setNewPreviewUrls = (files) => {
    if (!files || !files.length) return
    const newPreviewUrls = files
      .map((file) => {
        return isImage(file) ? URL.createObjectURL(file) : null
      })
      .filter(Boolean)

    setPreviewUrls((prevUrls) => [...prevUrls, ...newPreviewUrls])
  }

  const clearFiles = () => {
    setPreviewUrls([])
    setFiles({ imageFiles: [], documentFiles: [] })
  }

  const validateDocFileNames = (existingFiles, filesBelowLimit) => {
    if (!filesBelowLimit.length) return { ok: true, message: 'no data' }
    const existingDocFileNames = existingFiles.documentFiles.filter((f) => f.name && isDocFile(f)).map((_) => _.name)
    const docFileNames = filesBelowLimit.filter((f) => f.name && isDocFile(f)).map((_) => _.name)
    if (new Set(docFileNames).size !== docFileNames.length) {
      return { ok: false, message: 'ドキュメントファイルの名前の重複は避けてください。' }
    }
    for (const name of docFileNames) {
      if (existingDocFileNames.includes(name)) {
        return { ok: false, message: 'すでに同じ名前のドキュメントファイルが使用されています。' }
      }
    }
    return { ok: true, message: 'ok' }
  }

  // ファイル選択時のハンドラ
  const handleFilesChange = (e) => {
    const FilesSizelimit = file_size_limit
    const selectedFiles = Array.from(e.target.files) // ファイルのリストを配列に変換
    const filesBelowLimit = selectedFiles.filter((file) => file.size <= FilesSizelimit) // 3.5MB以下のファイルのみフィルタリング
    const filesAboveLimit = selectedFiles.length - filesBelowLimit.length // 3.5MB以上のファイルの数

    if (filesAboveLimit > 0) {
      const oversizedFilesAlert = selectedFiles
        .filter((file) => file.size > FilesSizelimit)
        .map((file) => `❏ ファイル名: ${file.name}`)
        .join('\n')
      if (oversizedFilesAlert) {
        alert(
          `1つの画像のサイズ上限は3.5MBです。3.5MBを超えている以下の画像のみ除外しました。\n\n${oversizedFilesAlert}`
        )
      }
    }

    const result = validateDocFileNames(files, filesBelowLimit)
    if (!result.ok) {
      alert(result.message)
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
      return
    }

    setNewFiles(filesBelowLimit)
    setNewPreviewUrls(filesBelowLimit)
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handlePaste = (event) => {
    const clipboardItems = event.clipboardData.items
    const FilesSizelimit = file_size_limit // ファイルサイズ上限 (3.5MB)
    const pastedFiles = []

    for (const item of clipboardItems) {
      if (isImage(item)) {
        const file = item.getAsFile()
        if (file && file.size <= FilesSizelimit) {
          pastedFiles.push(file)
        } else if (file) {
          alert(`画像サイズが3.5MBを超えています: ${file.name}`)
        }
      } else if (isDocFile(file)) {
        //TODO: docファイルの場合の処理を対応する？
      }
    }

    if (pastedFiles.length > 0) {
      setNewFiles(pastedFiles)
      setNewPreviewUrls(pastedFiles)
    }
  }

  useEffect(() => {
    const { role = '' } = userData
    setIsAdmin(role === 'admin')
    setIsTutor(role === 'tutor')
    setIsStudent(role === 'student')
  }, [userData])

  // useEffectを更新して、files配列が変更されたときにプレビューを設定
  useEffect(() => {
    // 以前のプレビューURLをクリーンアップ
    return () => {
      previewUrls.forEach((url) => URL.revokeObjectURL(url))
    }
  }, [previewUrls])

  const languageList2 = _language_list_v2
  useEffect(() => {
    setNewConversationId(conversationId)
    setPlayingIndex(null)
    setOnPlaying(false)
  }, [conversationId])
  useEffect(() => {
    setIsLargeIcon(largeIcon)
  }, [largeIcon])
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2
    if (t < 1) return (c / 2) * t * t + b
    t--
    return (-c / 2) * (t * (t - 2) - 1) + b
  }
  const containerRef = useRef(null)
  const modalRef = useRef()
  const avatorContainerRef = useRef(null)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsModalOpenForSubmission(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [setIsModalOpenForSubmission])
  const changeLanguage = (e) => {
    setSelectedLanguage(e.target.value)
  }
  const stopPlaying = () => {
    if (audio.current) {
      audio.current.pause()
      audio.current = null
    }
    if (_audio) {
      _audio.pause()
      setPlayingIndex(null)
      setOnPlaying(false)
    }
  }
  const changeMute = async () => {
    setIsMute(!isMute)
    const currentIsMute = Boolean(parseInt(localStorage.getItem('localIsMute'), 10))
    const numericValue = currentIsMute ? 0 : 1
    localStorage.setItem('localIsMute', numericValue)
    const localIsMute = localStorage.getItem('localIsMute')
    speechSynthesis.cancel()
    let text = 'コメント読み上げをオンにしました。'
    const json_lang = JSON.parse(selectedLanguage)
    if (json_lang.languageCode === 'en-US') {
      text = 'Comment reading turned on.'
    }
    if (localIsMute === '0') {
      let languageCode = 'ja-JP'
      let type = 'ja-JP-Neural2-B'
      if (json_lang.languageCode === 'en-US') {
        languageCode = 'en-US'
        type = json_lang.type
      } else if (json_lang.languageCode === 'ja-JP') {
        type = json_lang.type
      }
      audio.current = new Audio(await getAudioUrl({ text, languageCode, type, speakingRate }))
      _setAudio(audio.current)
      audio.current.play()
    } else {
      if (_audio) {
        _audio.pause()
        setPlayingIndex(null)
        setOnPlaying(false)
      }
    }
  }

  const replyRef = useRef(null)
  const scroll = (direction, scrollAmount = 100) => {
    if (!replyRef.current) return
    if (direction !== 'right' && direction !== 'left') return
    replyRef.current.scrollTo({
      left: replyRef.current.scrollLeft + (direction === 'right' ? scrollAmount : -scrollAmount),
      behavior: 'smooth'
    })
  }
  const [replyOverflowing, setReplyOverflowing] = useState(false)

  const debounceTimer = useRef(null)
  const overflowChecker = () => {
    if (debounceTimer.current) clearTimeout(debounceTimer.current)
    debounceTimer.current = setTimeout(async () => {
      await new Promise((_) => setTimeout(_, 1500))
      const element = replyRef?.current
      if (!element) return
      if (element.scrollWidth > element.clientWidth) {
        setReplyOverflowing(true)
      } else {
        setReplyOverflowing(false)
      }
      debounceTimer.current = null
    }, 250)
  }

  useEffect(() => {
    overflowChecker()
  }, [_start, _startButton, readOnly, conversation])
  useEffect(() => {
    overflowChecker()
    window.addEventListener('resize', overflowChecker)
    return () => {
      window.removeEventListener('resize', overflowChecker)
    }
  }, [])

  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    alert('お使いのブラウザは音声機能に対応していません。最新版のChromeかSafariをご利用ください。')
  }

  const listenContinuously = () => {
    resetTranscript()
    setIsListening(true)
    const json_lang = JSON.parse(selectedLanguage)
    SpeechRecognition.startListening({
      continuous: true,
      language: json_lang.physicalName
    })
  }

  const resetListening = () => {
    SpeechRecognition.stopListening()
    setIsListening(false)
  }

  const onVoiceInput = () => {
    setPreviousChatInput(chatInput)
    listenContinuously()
  }
  const onChangeImage = (e) => {
    const file = e.target.files[0]
    const reader = new FileReader()
    reader.onload = async (e) => {
      const text = await ocr(file)
      setChatInput(text)
    }
    reader.readAsDataURL(file)
  }

  const handleInputChange = (event) => {
    setChatInput(event.target.value)
  }

  const isWithinThreadSendingLimit = () => {
    // 送信回数がスレッドあたりの制限内かどうかを判断するロジック
    if (isSendingCountLimit) {
      const userSendingCount = chatData.filter((chat) => chat.role === 'user').length + 1
      if (maximumSendingCountLimit < userSendingCount) {
        alert(
          `このスレッドの送信回数上限に達しました。\n` +
            `・現在の送信回数: ${userSendingCount - 1}\n` +
            `・このモードの1スレッドあたりの送信回数の上限値: ${maximumSendingCountLimit}\n\n` +
            `引き続きご利用する場合は、モード一覧画面からモードを選択して新しい会話を作成してください。`
        )
        return true
      } else {
        return false
      }
    }
  }

  const isWithinThreadCharacterLimitPerDay = (text) => {
    // 送信回数がスレッドあたりの制限内かどうかを判断するロジック
    if (characterLimit === true && maxCharacters) {
      const startTime = new Date()
      startTime.setHours(0, 0, 0, 0) // Set to the beginning of the day
      const endTime = new Date() // Current time
      endTime.setDate(endTime.getDate() + 1) // Set to the beginning of the next day
      endTime.setHours(0, 0, 0, 0) // Set to 00:00:00
      const { userCharacterCount, totalCharacterCount } = checkCharacterCount(
        text,
        ['user', 'system', 'assistant'],
        startTime.getTime(),
        endTime.getTime()
      )
      if (totalCharacterCount > maxCharacters) {
        // maxCharacters文字以上の場合、アラートを表示するか、適切な処理を行う
        const remainingCharacterCount = maxCharacters - userCharacterCount

        if (remainingCharacterCount <= 0) {
          alert(
            `文字数制限を超えており、今日はこの会話ではメッセージの送信ができません。\n明日になると制限がリセットされ、再び送信できるようになります。`
          )
        } else {
          alert(
            `今日はこの会話では残り${remainingCharacterCount}文字までしか送信できません。\n文字数を減らしてください。\n明日になると制限がリセットされます。`
          )
        }

        return true
      } else {
        return false
      }
    }
  }
  const isWithinThreadCharacterLimitPerMonth = (text) => {
    // 送信回数がスレッドあたりの制限内かどうかを判断するロジック
    if (characterLimitPerMonth === true && maxCharactersPerMonth) {
      const startTime = new Date()
      startTime.setDate(1) // Set to the first day of the current month
      startTime.setHours(0, 0, 0, 0) // Set to 00:00:00

      const endTime = new Date(startTime)
      endTime.setMonth(endTime.getMonth() + 1) // Set to the first day of the next month
      endTime.setHours(0, 0, 0, 0) // Set to 00:00:00
      const { userCharacterCount, totalCharacterCount } = checkCharacterCount(
        text,
        ['user', 'system', 'assistant'],
        startTime.getTime(),
        endTime.getTime()
      )
      if (totalCharacterCount > maxCharactersPerMonth) {
        const remainingCharacterCount = maxCharactersPerMonth - userCharacterCount

        if (remainingCharacterCount <= 0) {
          alert(
            `文字数制限を超えており、今月はこの会話ではメッセージの送信ができません。\n来月になると制限がリセットされ、再び送信できるようになります。`
          )
        } else {
          alert(
            `今月はこの会話では残り${remainingCharacterCount}文字までしか送信できません。\n文字数を減らしてください。\n来月になると制限がリセットされます。`
          )
        }
        return true
      } else {
        return false
      }
    }
  }

  // eslint-disable-next-line
  const addMessageToDB = async (message, threadId, messagesForTokenCounter, option = { isError: false }) => {
    // 初回AssistantAPIでthreadIdが作成されたときのみthreadIdを引数に渡してconversationDoc更新する
    playTextSound('')
    const userDocRef = doc(db, 'users', user.uid)
    const conversationsDocRef = doc(
      userDocRef,
      conversationType,
      newConversationId ? newConversationId : state.conversationId
    )

    const messagesCollectionRef = collection(conversationsDocRef, 'messages')
    const ref = doc(messagesCollectionRef)
    const { data } = await tokenCounter({
      text: message.content,
      role: message.role,
      model: model,
      messagesForTokenCounter: messagesForTokenCounter // 過去の会話履歴を含む
    })
    const { characterCount, tokenCount, tokenCountOfMessages } = data
    if (threadId) {
      await updateDoc(conversationsDocRef, {
        updatedAt: new Date().getTime(),
        threadId: threadId
      })
    } else {
      await updateDoc(conversationsDocRef, {
        updatedAt: new Date().getTime()
      })
    }
    const _data = {
      messageId: ref.id,
      message: message.content,
      displayMessage: message.displayMessage || null,
      role: message.role,
      model,
      createdAt: message.messageTime,
      characterCount,
      tokenCount,
      tokenCountOfMessages, // 過去の会話履歴を含む
      actualMessageLength: message.actualMessageLength || message.characterCount,
      ...(option.isError ? { isError: true } : {})
    }
    await setDoc(ref, _data)
    const newMessageRef = ref
    const updatedUserChatMesasge = {
      ...message,
      messageId: ref.id,
      model,
      characterCount,
      tokenCount,
      tokenCountOfMessages // 過去の会話履歴を含む
    }
    setChatData((prevChatData) => {
      const newChatData = [...prevChatData]
      newChatData[prevChatData.length - 1] = { ...prevChatData[prevChatData.length - 1], ref: newMessageRef }
      return newChatData
    })
    return { newMessageRef, updatedUserChatMesasge }
  }

  const [onPlaying, setOnPlaying] = useState(false)
  const [isAudioGenerating, setIsAudioGenerating] = useState(false)
  const [playingIndex, setPlayingIndex] = useState(null)

  const playTextSound = async (text, lang = '', play = false, index = null) => {
    const localIsMute = Boolean(parseInt(localStorage.getItem('localIsMute'), 10))
    if (text === '' || (play !== true && (localIsMute === true || localIsMute === null))) return

    setIsAudioGenerating(true)
    setOnPlaying(true)
    setPlayingIndex(index !== null ? index : chatData.length + 1)

    let languageCode = 'en-US'
    let type = 'en-US-Neural2-H'

    if (lang) {
      const json_lang = JSON.parse(lang)
      languageCode = json_lang.languageCode
      type = json_lang.type
    } else if (selectedLanguage) {
      const json_lang = JSON.parse(selectedLanguage)
      languageCode = json_lang.languageCode
      type = json_lang.type
    }

    const audioUrlFunction = type === 'openai-tts' ? getAudioUrlFromOpenAi : getAudioUrl
    audio.current = new Audio(await audioUrlFunction({ text, languageCode, type, speakingRate }))

    setIsAudioGenerating(false)

    _setAudio(audio.current)

    return new Promise((resolve, reject) => {
      audio.current.onended = () => {
        setPlayingIndex(null)
        setOnPlaying(false)
        resolve()
      }
      audio.current.onerror = (error) => {
        console.error('Playback failed', error)
        reject(error)
      }
      audio.current.play().catch(reject)
    })
  }

  const [messageList, setMessageList] = useState([])
  const [runStatus, setRunStatus] = useState('')
  const [_threadId, _setThreadId] = useState(threadId && threadId)
  const [runId, setRunId] = useState('')
  const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }
  const getRunStatus = async (runId, threadId) => {
    setIsGenerating(true)
    let count = 0
    let status = ''
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/open_ai_get_run_status'
    while (count < 50 && status !== 'completed') {
      const res = await fetch(URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          thread_id: threadId,
          run_id: runId
        })
      })
      const { run } = await res.json()
      status = run.status
      setRunStatus(status)
      await sleep(3000)
      count++
    }
    setIsGenerating(false)
    return status
  }

  const loadingChatMessage = {
    role: 'loading',
    content: 'loading...',
    messageTime: new Date().getTime(),
    characterCount: ''
  }

  const createThreadAndRun = async ({ pastContent }) => {
    setIsLoading(false)

    setMessageList([])

    const _URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/open_ai_create_thread_and_run'
    const messages = [
      // これがsystem promp相当のデータ
      {
        role: 'user', // system promprだが、roleはuserにする

        content: pastContent[0].content
      }
    ]

    setMessageList([{ value: messages[0].content, created_at: new Date() }])
    try {
      const res = await fetch(_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ assistant_id: assistantId, messages })
      }).catch((error) => {
        // ネットワークエラーなどの場合
        console.error('Fetch error:', error)
        // alert('Network error or cannot reach the server.')
        return false // 失敗を示す
      })

      if (!res.ok) {
        // HTTPエラーステータスが返された場合
        // alert(`Error: ${res.status} ${res.statusText}`)
        return false // 失敗を示す
      } else {
        setChatData([...pastContent, loadingChatMessage])
        const { run } = await res.json()
        const runId = run.id
        const thread_id = run.thread_id
        _setThreadId(thread_id)
        setRunId(runId)
        // クエリパラメータの変更
        const currentUrl = new URL(window.location) // 修正: `href`を使用
        currentUrl.searchParams.set('thread_id', thread_id)
        window.history.pushState({}, '', currentUrl)

        const runStatus = await getRunStatus(runId, thread_id)
        if (runStatus === 'completed') {
          const messageList = await _getMessages(thread_id)

          if (messageList.length > 0) {
            // messageList の最後の要素を取得
            const lastMessage = messageList[messageList.length - 1]

            // pastContent に lastMessage を結合して setChatData に適用
            setChatData([...pastContent, lastMessage])
            playTextSound(lastMessage.content, selectedLanguage)
            // 結合した結果をログに出力
            const gptChatMessage = {
              role: lastMessage.role,
              content: lastMessage.content,
              messageTime: new Date().getTime(),
              actualMessageLength: lastMessage.content.length
            }
            const messagesForTokenCounter = [{ role: gptChatMessage.role, content: gptChatMessage.content }]
            addMessageToDB(gptChatMessage, thread_id, messagesForTokenCounter)
          } else {
            // messageList が空の場合は、何らかの処理を行うか、または何もしない
          }
        }
      }
      return true // 成功を示す
    } catch (error) {
      console.error('Fetch error:', error)
      // alert('Network error or cannot reach the server.')
      return false // 失敗を示す
    }
  }

  const createThreadAndRunForAzure = async ({ pastContent }) => {
    setIsLoading(false)
    setIsGenerating(true)
    setDisableSpeaker(true)
    setChatData([...chatData, ...pastContent, loadingChatMessage])
    let thread_id = ''
    const _URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/azure_create_thread_and_run'
    const messages = [
      {
        role: 'user', // system promptだが、roleはuserにする
        content: pastContent[0].content
      }
    ]
    setMessageList([{ value: messages[0].content, created_at: new Date() }])
    try {
      const requestJson = {
        assistant_id: assistantId,
        messages: messages.map((message) => {
          return {
            role: message.role,
            content: message.content + '\n※file_citationは出力しなくていいです'
          }
        })
      }
      const controller = new AbortController()
      const res = await fetch(_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestJson),
        signal: controller.signal // AbortController の signal を渡す
      })
      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`)
      }

      if (!res.ok) {
        // HTTPエラーステータスが返された場合
        // alert(`Error: ${res.status} ${res.statusText}`)
        return false // 失敗を示す
      } else {
        const reader = res.body.getReader()
        const decoder = new TextDecoder('utf-8')
        let count = 0
        let jsons = []
        let message = ''
        let assistantChatMessage = {}
        const read = async (missingJson = '') => {
          const { done, value } = await reader.read()
          if (done) {
            return reader.releaseLock()
          }
          const chunk = decoder.decode(value, { stream: true })
          const trimData = chunk.trim()

          /////////////////////
          // 最初のJSONオブジェクトを抽出
          const jsonStrings = trimData.split(/(?={"event":)/)
          if (trimData === '' || trimData === '[DONE]') {
            jsons = []
          } else {
            // 各JSON文字列を個別にパースして処理
            jsons = jsonStrings.map((jsonString) => {
              try {
                const parsedJson = JSON.parse(missingJson + jsonString)
                missingJson = ''
                // 必要に応じてparsedJsonを操作
                return parsedJson
              } catch (error) {
                console.error('JSONパースエラー:', error, '問題のある文字列:', jsonString)
                missingJson = jsonString
                return undefined
              }
            })
          }
          const messageTime = new Date().getTime()
          for (let json of jsons) {
            if (json && (json.event === 'thread.run.failed' || json.event === 'thread.run.step.failed')) {
              message = 'エラーが発生しました。少し時間を空けて、もう一度お試しください'
              assistantChatMessage = {
                role: 'assistant',
                content: message,
                messageTime,
                characterCount: message.length
              }
              setChatData([...chatData, ...pastContent, assistantChatMessage])
              return reader.releaseLock()
            }
            if (json && json.event === 'thread.created') {
              thread_id = json.data.id
              _setThreadId(thread_id)
              const currentUrl = new URL(window.location) // 修正: `href`を使用
              currentUrl.searchParams.set('thread_id', thread_id)
              window.history.pushState({}, '', currentUrl)
            }
            if (json && json.event === 'thread.message.delta') {
              message += json.data.delta.content[0].text.value
              assistantChatMessage = {
                role: 'assistant',
                content: message,
                messageTime,
                characterCount: message.length
              }
              setChatData([...chatData, ...pastContent, assistantChatMessage])
              count = count + 1
              setIsActiveAvator(count)
            }
          }
          return read(missingJson)
        }
        await read()
        playTextSound(message, selectedLanguage)
        const gptChatMessage = {
          role: 'assistant',
          content: message,
          messageTime: new Date().getTime(),
          actualMessageLength: message.length
        }
        const messagesForTokenCounter = [{ role: gptChatMessage.role, content: gptChatMessage.content }]
        await addMessageToDB(gptChatMessage, thread_id, messagesForTokenCounter)
        setDisableSpeaker(false)
        setIsGenerating(false)
      }
      return true // 成功を示す
    } catch (error) {
      console.error('Fetch error:', error)
      return false // 失敗を示す
    }
  }

  const _getMessages = async (threadId) => {
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/open_ai_get_messages'
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        thread_id: threadId
      })
    })
    const data = await res.json()
    const messageList = data.threadMessagesData
      .map((d) => {
        const content = d.content
        const { type } = content[0]
        if (type === 'text') {
          return { role: 'assistant', content: content[0].text.value, created_at: d.created_at }
        } else {
          return null
        }
      })
      .filter((message) => message !== null)
      .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))

    setMessageList(messageList)
    return messageList
  }

  const createMessage = async (userChatMessage) => {
    setIsLoading(false)
    setChatData([...chatData, userChatMessage, loadingChatMessage])
    const messageInput = userChatMessage.content
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/open_ai_create_message'
    const message = {
      role: 'user',
      content: messageInput
    }
    setMessageList([...messageList, { value: messageInput, created_at: new Date() }])
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ thread_id: _threadId, message })
    }).catch((error) => {
      // ネットワークエラーなどの場合
      console.error('Fetch error:', error)
      alert('Network error or cannot reach the server.')
      return false // 失敗を示す
    })
    if (!res.ok) {
      // HTTPエラーステータスが返された場合
      alert(`Error: ${res.status} ${res.statusText}`)
      return false // 失敗を示す
    } else {
      const data = await res.json()
      const assistantChatMessage = await runThread()
      setChatData([...chatData, userChatMessage, assistantChatMessage])
      const messagesForTokenCounter = [{ role: assistantChatMessage.role, content: assistantChatMessage.content }]
      addMessageToDB(assistantChatMessage, _threadId, messagesForTokenCounter)
      return true // 失敗を示す
    }
  }

  const createMessageForAzure = async (userChatMessage) => {
    setIsLoading(false)
    setChatData([...chatData, userChatMessage, loadingChatMessage])
    const messageInput = userChatMessage.content

    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/azure_create_message'
    const message = {
      role: 'user',
      content: messageInput
    }
    setMessageList([...messageList, { value: messageInput, created_at: new Date() }])
    const res = await fetch(URL, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        thread_id: _threadId,
        message
      })
    }).catch((error) => {
      // ネットワークエラーなどの場合
      console.error('Fetch error:', error)
      alert('Network error or cannot reach the server.')
      return false // 失敗を示す
    })
    if (!res.ok) {
      // HTTPエラーステータスが返された場合
      alert(`Error: ${res.status} ${res.statusText}`)
      return false // 失敗を示す
    } else {
      const { threadMessages } = await res.json()
      const runResult = await createRun({ userChatMessage })
      // const data = await res.json()
      // const assistantChatMessage = await runThread()
      // setChatData([...chatData, userChatMessage, assistantChatMessage])
      // const messagesForTokenCounter = [{ role: assistantChatMessage.role, content: assistantChatMessage.content }]
      // addMessageToDB(assistantChatMessage, _threadId, messagesForTokenCounter)
      return runResult // 失敗を示す
    }
  }

  const createRun = async ({ userChatMessage }) => {
    setIsGenerating(true)
    setDisableSpeaker(true)
    const controller = new AbortController()
    const assistant_id = assistantId
    const thread_id = _threadId
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/azure_create_run'
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ assistant_id, thread_id }),
      signal: controller.signal // AbortController の signal を渡す
    })
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }
    const reader = response.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let count = 0
    let jsons = []
    let message = ''
    let assistantChatMessage = {}
    const read = async (missingJson = '') => {
      const { done, value } = await reader.read()
      if (done) {
        return reader.releaseLock()
      }
      const chunk = decoder.decode(value, { stream: true })
      const trimData = chunk.trim()

      /////////////////////
      // 最初のJSONオブジェクトを抽出
      const jsonStrings = trimData.split(/(?={"event":)/)
      if (trimData === '' || trimData === '[DONE]') {
        jsons = []
      } else {
        // 各JSON文字列を個別にパースして処理
        jsons = jsonStrings.map((jsonString) => {
          try {
            const parsedJson = JSON.parse(missingJson + jsonString)
            missingJson = ''
            // 必要に応じてparsedJsonを操作
            return parsedJson
          } catch (error) {
            console.error('JSONパースエラー:', error, '問題のある文字列:', jsonString)
            missingJson = jsonString
            return undefined
          }
        })
      }
      const messageTime = new Date().getTime()
      for (let json of jsons) {
        if (json && (json.event === 'thread.run.failed' || json.event === 'thread.run.step.failed')) {
          message = 'エラーが発生しました。少し時間を空けて、もう一度お試しください'
          assistantChatMessage = {
            role: 'assistant',
            content: message,
            messageTime,
            characterCount: message.length
          }
          setChatData([...chatData, userChatMessage, assistantChatMessage])
          return reader.releaseLock()
        }
        if (json && json.event === 'thread.created') {
          thread_id = json.data.id
          _setThreadId(thread_id)
          const currentUrl = new URL(window.location) // 修正: `href`を使用
          currentUrl.searchParams.set('thread_id', thread_id)
          window.history.pushState({}, '', currentUrl)
        }
        if (json && json.event === 'thread.message.delta') {
          message += json.data.delta.content[0].text.value
          assistantChatMessage = {
            role: 'assistant',
            content: message,
            messageTime,
            characterCount: message.length
          }
          setChatData([...chatData, userChatMessage, assistantChatMessage])
          count = count + 1
          setIsActiveAvator(count)
        }
      }
      return read(missingJson)
    }
    await read()
    playTextSound(message, selectedLanguage)
    const messagesForTokenCounter = [{ role: assistantChatMessage.role, content: assistantChatMessage.content }]
    await addMessageToDB(assistantChatMessage, thread_id, messagesForTokenCounter)
    setIsGenerating(false)
    setDisableSpeaker(false)
    return true // 成功を示す
  }

  const runThread = async () => {
    const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/open_ai_run_thread'
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        thread_id: _threadId,
        assistant_id: assistantId
      })
    })
    const { run } = await res.json()
    const runId = run.id
    setRunId(runId)
    const runStatus = await getRunStatus(runId, _threadId)
    if (runStatus === 'completed') {
      const messageList = await _getMessages(_threadId)

      if (messageList.length > 0) {
        // messageList の最後の要素を取得
        const lastMessage = messageList[messageList.length - 1]
        playTextSound(lastMessage.content, selectedLanguage)
        const assistantChatMessage = {
          role: 'assistant',
          content: lastMessage.content,
          messageTime: new Date().getTime(),
          actualMessageLength: lastMessage.content.length
        }
        return assistantChatMessage
      } else {
        // messageList が空の場合は、何らかの処理を行うか、または何もしない
      }
    } else {
    }
  }

  const [abortController, setAbortController] = useState(null)
  useEffect(() => {
    // コンポーネントのクリーンアップ時にストリームをキャンセル
    return () => {
      if (abortController) {
        abortController.abort()
      }
    }
    // conversationIdが変更された時もabortされるようにした
  }, [abortController])
  useEffect(() => {
    if (window.location.pathname === '/submitted_conversations')
      // コンポーネントのクリーンアップ時にストリームをキャンセル
      return () => {
        if (abortController) {
          abortController.abort()
          setAbortController(null) // コントローラのリセット
        }
      }
    // conversationIdが変更された時もabortされるようにした
  }, [conversationId])
  // ストリームをキャンセルするためのボタンのイベントハンドラ
  const handleCancelStream = () => {
    // console.log('chatData', chatData)
    const filteredChatData = chatData.filter((item) => item.role !== 'loading')
    // console.log('filteredChatData', filteredChatData)
    setChatData(filteredChatData)
    if (abortController) {
      abortController.abort()
      setAbortController(null) // コcントローラのリセット
    }
  }
  const getGptStreamResponse = async ({ model, prompt, pastContent, lang, temperature }) => {
    const controller = new AbortController()
    let allMessages = prompt
    setAbortController(controller)
    setIsLoading(false)
    setChatData([...chatData, ...pastContent, loadingChatMessage])
    setIsGenerating(true)
    let reader, decoder
    let count = 0
    let message = ''
    const gptModelDetails = _gpt_model.find((item) => item.value === model)
    try {
      if (gptModelDetails.provider === 'anthropic') {
        ;[reader, decoder] = await getClaudeStreamingMessageReaderAndDecoder({
          model,
          messages: allMessages,
          temperature: temperature,
          controller
        })
      } else if (gptModelDetails.provider === 'amazon') {
        ;[reader, decoder] = await getAmazonBedrockStreamingMessageReaderAndDecoder({
          model,
          anthropic_version: gptModelDetails.anthropic_version ? gptModelDetails.anthropic_version : '',
          messages: allMessages,
          temperature: temperature,
          controller
        })
      } else if (gptModelDetails.provider === 'microsoft') {
        // console.log('Azure')
        ;[reader, decoder] = await getAzureAIStreamingMessageReaderAndDecoder({
          model,
          messages: allMessages,
          temperature: temperature,
          controller
        })
      } else {
        console.log('allMessages', allMessages)
        ;[reader, decoder] = await getGptStreamingMessageReaderAndDecoder({
          model,
          messages: allMessages,
          temperature: temperature,
          controller
        })
      }
    } catch (error) {
      setDisableSpeaker(false)
      setIsGenerating(false)

      const { reason } = await handleErrorDetail(error.details, userData, allMessages)
      const gptChatMessage = {
        role: 'assistant',
        content:
          reason === 'content_filter'
            ? 'コンテンツフィルタによりメッセージの送信が拒否されました。'
            : 'エラーが発生しました。',
        messageTime: new Date().getTime(),
        get actualMessageLength() {
          return this.content.length
        }
      }
      const messagesForTokenCounter = [{ role: gptChatMessage.role, content: gptChatMessage.content }]
      setChatData([...chatData, ...pastContent, gptChatMessage])
      count = count + 1
      setIsActiveAvator(count)
      await addMessageToDB(gptChatMessage, '', messagesForTokenCounter, { isError: true })
      return
    }
    try {
      const read = async (missingJson = '') => {
        const { done, value } = await reader.read()
        setDisableSpeaker(true)

        if (done) {
          return reader.releaseLock()
        }
        const chunk = decoder.decode(value, { stream: true })
        const jsons = chunk
          .split('data:')
          .map((data) => {
            const trimData = data.trim()
            if (trimData === '' || trimData === '[DONE]') return undefined
            try {
              const jsonObj = JSON.parse(missingJson + trimData)
              missingJson = ''
              return jsonObj
            } catch (e) {
              missingJson = trimData
              return undefined
            }
          })
          .filter((data) => data)
        const messageTime = new Date().getTime()
        ///////////////////////////
        //  Azure OpenAI Service の Stream 出力をスムーズに見せかけるトリック (see: https://qiita.com/nohanaga/items/eea68e0b7a0f417c5276)
        for (let test of jsons) {
          await new Promise((resolve) => {
            setTimeout(() => {
              if ((test.choices && test.choices.length !== 0) || test.text !== undefined) {
                if ((test.choices && test.choices[0].delta.content !== undefined) || test.text !== undefined) {
                  message += test.choices ? test.choices[0].delta.content : test.text
                  const assistantChatMessage = {
                    role: 'assistant',
                    content: message,
                    messageTime,
                    characterCount: message.length
                  }
                  setChatData([...chatData, ...pastContent, assistantChatMessage])
                  count = count + 1
                  setIsActiveAvator(count)
                }
              }
              resolve(null)
            }, 33)
          })
        }
        return read(missingJson)
      }
      await read()
      playTextSound(message, lang)
      const gptChatMessage = {
        role: 'assistant',
        content: message,
        messageTime: new Date().getTime(),
        actualMessageLength: message.length
      }
      const messagesForTokenCounter = [{ role: gptChatMessage.role, content: gptChatMessage.content }]
      await addMessageToDB(gptChatMessage, '', messagesForTokenCounter)
      setDisableSpeaker(false)
      setIsGenerating(false)
    } catch (e) {
      if (e.name === 'AbortError') {
        setDisableSpeaker(false)
        setIsGenerating(false)
        reader.releaseLock()
        const gptChatMessage = {
          role: 'assistant',
          content: message,
          messageTime: new Date().getTime(),
          actualMessageLength: message.length
        }
        const messagesForTokenCounter = [{ role: gptChatMessage.role, content: gptChatMessage.content }]
        addMessageToDB(gptChatMessage, '', messagesForTokenCounter)
      } else {
        console.error(e)
        reader.releaseLock()
      }
      setDisableSpeaker(false)
      setIsGenerating(false)
    }
  }

  const validateAvailability = (conversation) => {
    if (!conversation) return { available: false, failureReasons: ['会話が見つかりません。'] }
    const failureReasons = []
    if (!isAvailableNow(conversation)) failureReasons.push('この時間は利用できません。')
    if (!isAvailableWhenDisabled(conversation)) failureReasons.push('無効に設定されている会話は利用できません。')

    return { available: failureReasons.length === 0, failureReasons }
  }

  const isAvailableNow = (conversation) => {
    if (!conversation) return false
    const { hasTimeWindowLimit = false, timeWindows = [] } = conversation
    if (!hasTimeWindowLimit) return true
    if (!timeWindows.length) return false
    const now = dayjs()
    return timeWindows.some((w) => {
      const { start: _start, end: _end } = w
      if (!_start || !_end) return false
      const [sh, sm] = _start.split(':').map((_) => +_)
      const [eh, em] = _end.split(':').map((_) => +_)
      const start = dayjs().startOf('day').hour(sh).minute(sm)
      const end = dayjs().startOf('day').hour(eh).minute(em)
      // 不正なデータはfalseとして評価しない
      if (start.isAfter(end)) return false
      return now.isAfter(start) && now.isBefore(end)
    })
  }

  const isAvailableWhenDisabled = (conversation) => {
    if (!conversation) return false
    const { isEnabled = false, isAvailableWhenDisabled = false } = conversation
    return isEnabled ? true : isAvailableWhenDisabled
  }

  const createPrompt = (pastContent, content, option = { hasDocInput: false, hasImageInput: false, imageUrls: [] }) => {
    const { hasImageInput, imageUrls } = option

    if (!hasImageInput) {
      return [
        ...pastContent,
        {
          role: 'user',
          content
        }
      ]
    } else {
      return [
        ...pastContent,
        {
          role: 'user',
          content: [
            {
              type: 'text',
              text: content
            },
            ...imageUrls
          ]
        }
      ]
    }
  }

  const getExcelContent = async (documentFiles) => {
    let excelContentToString = ''
    if (!documentFiles || !documentFiles.length) return { excelContentToString, errors: [] }
    const { data, message = '', errors = [] } = await handleExcelFiles(documentFiles)
    if (data && Object.keys(data).length > 0) {
      excelContentToString = `
      添付するExcelファイルの情報をJSON形式にまとめました。
      ただし、特に指示がない限りはJSONデータをそのまま見せる回答を避けてください。見つかった情報をテーブル形式に整理して回答するようにしてください。
      また、列が何を意味しているのか適切に判断し、テーブル形式に整理する際には列がずれてデータの整合性を損なわないように細心の注意を払ってください。
      形式としては以下です。
      { workbook1 : { sheet1: [[rowの値],[次のrowの値],[次のrowの値]...] }, 以下、sheetが同様に... 
        workbook2 : { sheet1: [[rowの値],[次のrowの値],[次のrowの値]...] }, 以下、sheetが同様に... 
      }
      また、rowの値に数式が含まれる場合、{formula: 数式, value: 計算された値}というオブジェクトになります。こちらも、JSONを直接露出させることなく、ユーザーに見やすい形で表現してください。
      以下、JSONデータ
      ===========================
      ${JSON.stringify(data)}`.replace(/^\s+/gm, '')
    } else {
      // TODO: エラーになったファイル名を返答に入れるなどしてユーザーに明示したい
      if (errors.length) {
        console.error('excel dataの取得に失敗', { message, errors })
      }
    }

    return { excelContentToString, errors }
  }

  const validateExcelContentsLength = (content) => {
    const MAX_LENGTH = 5000
    if (!content) return { ok: true }
    return { ok: content.length <= MAX_LENGTH, max_length: MAX_LENGTH, content_length: content.length }
  }

  // eslint-disable-next-line
  const onTextInput = async (text, optionMessage = '') => {
    if (isStudent && conversation) {
      const result = validateAvailability(conversation)
      if (!result.available) {
        const alertText = `利用できません。\n${result.failureReasons.join('\n')}`
        window.alert(alertText)
        return
      }
    }

    setIsGenerating(true)
    const matchingModel = _gpt_model.find((item) => item.value === model)
    let isStreamingModel = true
    if (matchingModel.hasOwnProperty('streaming') && matchingModel.streaming !== true) {
      isStreamingModel = false
    }
    // firebaseに登録される前一時的にローカールデータで表示
    let content = text ? text : chatInput
    if (isWithinThreadSendingLimit()) return
    if (isWithinThreadCharacterLimitPerDay(content)) return
    if (isWithinThreadCharacterLimitPerMonth(content)) return

    let excelContentToString = ''
    if (files.documentFiles.length > 0) {
      const { excelContentToString: _excelContentToString } = await getExcelContent(files.documentFiles)
      const result = validateExcelContentsLength(_excelContentToString)
      if (result.ok) {
        excelContentToString = _excelContentToString
      } else {
        const diff = (result.content_length / result.max_length) * 100
        alert(`添付されたExcelファイルの容量が制限値の約${Math.floor(diff)}%になっています。容量を減らしてください。`)
        setIsGenerating(false)
        return
      }
    }

    if (chatInput && previewUrls.length > 0) {
      const formatPreviewUrls = (previewUrls) => {
        return previewUrls.map((url) => ({
          image_url: {
            url: url
          },
          type: 'image_url'
        }))
      }
      setChatData([
        ...chatData,
        {
          role: 'user',
          content: [
            {
              type: 'text',
              text: chatInput
            },
            ...formatPreviewUrls(previewUrls)
          ],
          displayMessage: optionMessage
        }
      ])
    } else if (chatInput) {
      setChatData([
        ...chatData,
        {
          role: 'user',
          content: chatInput,
          displayMessage: optionMessage
        }
      ])
    }
    setChatInput('')

    const actualMessageLength = chatData.reduce((total, chat) => total + chat.content.length, 0) + content.length
    let userChatMessage = {}

    userChatMessage = {
      role: 'user',
      content: content,
      displayMessage: optionMessage,
      messageTime: new Date().getTime(),
      actualMessageLength: actualMessageLength
    }
    const chatDataForGpt = chatData.map((item, index) => {
      return {
        role: item.role,
        content: item.excelContents ? item.content + '\n' + item.excelContents : item.content
      }
    })

    let pastContent = []
    let imageUrls = []
    let docFiles = []
    let prompt = []
    if (isPastMessageLimitCountSet === true) {
      const systemPrompt = chatDataForGpt.filter((item) => item.role === 'system')
      const n = maximumPastMessageLimitCount - 1
      const slicedChatDataForGPT = n > 0 ? chatDataForGpt.slice(-n) : []
      pastContent = [...systemPrompt, ...slicedChatDataForGPT]
    } else {
      pastContent = chatDataForGpt
    }
    const messagesForTokenCounter = pastContent

    // 添付ファイルがある時
    if (Object.values(files).some((f) => f.length > 0)) {
      let _content = content
      // まずは何もせず保存する
      const { newMessageRef, updatedUserChatMesasge } = await addMessageToDB(
        userChatMessage,
        '',
        messagesForTokenCounter
      )
      userChatMessage = updatedUserChatMesasge

      const { imageFiles, documentFiles } = files

      if (documentFiles.length > 0) {
        docFiles = documentFiles
          .filter((_) => _)
          .map((file) => ({
            type: 'document_file',
            file_name: file.name ?? '不明なファイル'
          }))
      }

      // 画像があるか評価
      let imageInfo = null
      if (imageFiles.length > 0) {
        imageInfo = await Promise.all(
          imageFiles.map(async (imageFile, index) => {
            const iconImagePath = `conversationPictures/${user.uid}/${newConversationId}/${newMessageRef.id}/${
              index + 1
            }`
            const storageRef = ref(storage, iconImagePath)
            try {
              const uploadSnapshot = await uploadBytes(storageRef, imageFile)
              const iconImageUrl = await getDownloadURL(uploadSnapshot.ref)
              return {
                iconImageUrl,
                iconImagePath: uploadSnapshot.metadata.fullPath || ''
              }
            } catch (error) {
              console.error(`画像${index + 1}のエラー:`, error)
              return null
            }
          })
        )

        imageUrls = imageInfo.map((info) => ({
          type: 'image_url',
          image_url: {
            url: info.iconImageUrl
          }
        }))

        _content = [
          {
            type: 'text',
            text: _content
          },
          ...imageUrls
        ]
      }

      userChatMessage = {
        ...userChatMessage,
        content: _content,
        messageTime: new Date().getTime(),
        imageInfo,
        docFiles,
        excelContents: excelContentToString
      }

      try {
        // Firestoreに反映
        await updateDoc(newMessageRef, {
          message: _content,
          imageInfo,
          docFiles,
          excelContents: excelContentToString
        })
      } catch (error) {
        console.error('doc更新エラー:', error)
      }
      clearFiles()

      prompt = createPrompt(pastContent, content + '\n' + excelContentToString, {
        hasImageInput: true,
        imageUrls: imageUrls ?? []
      })
    } else {
      const { updatedUserChatMesasge } = await addMessageToDB(userChatMessage, '', messagesForTokenCounter)
      userChatMessage = updatedUserChatMesasge
      prompt = createPrompt(pastContent, content)
    }

    setChatData([...chatData, userChatMessage])

    setIsGenerating(true)
    if (isStreamingModel) {
      if (_useAssistantApi) {
        let success
        if (!_threadId) {
          if (model && model.includes('azure')) {
            success = await createThreadAndRunForAzure({ pastContent: [userChatMessage] })
          } else {
            success = await createThreadAndRun({ pastContent: [userChatMessage] })
          }
        } else {
          if (model && model.includes('azure')) {
            success = await createMessageForAzure(userChatMessage)
          } else {
            success = await createMessage(userChatMessage)
          }
        }
        if (!success) {
          _setUseAssistantApi(null)
          await getGptStreamResponse({ model, prompt, pastContent: [userChatMessage], temperature })
        }
      } else {
        await getGptStreamResponse({ model, prompt, pastContent: [userChatMessage], temperature })
      }
    } else {
      setIsStreaming(true)
      setChatData([...chatData, ...[userChatMessage, loadingChatMessage]])
      let res
      let message
      try {
        if (model && model.includes('azure')) {
          res = await getAzureGptMessage({ model, prompt: prompt })
        } else {
          res = await getGptMessage({ model, prompt: prompt })
        }
        message = res.data.message
      } catch (e) {
        console.error('error', e)
        message = 'エラーが発生しました。'
      }
      playTextSound(message)
      const gptChatMessage = {
        role: 'assistant',
        content: message,
        messageTime: new Date().getTime(),
        characterCount: message.length,
        actualMessageLength: message.length
      }
      const messagesForTokenCounter = [{ role: gptChatMessage.role, content: gptChatMessage.content }]
      addMessageToDB(gptChatMessage, '', messagesForTokenCounter)
      setChatData([...chatData, ...[userChatMessage, gptChatMessage]])
    }
    setIsLoading(false)
    setIsGenerating(false)
    setIsStreaming(false)
  }

  const checkCharacterCount = (latestMessage, roles, startTime, endTime) => {
    const filteredMessages = chatData.filter(
      (message) => roles.includes(message.role) && message.messageTime >= startTime && message.messageTime < endTime
    )
    if (latestMessage.length === 0) {
      const totalCharacterCount = filteredMessages.reduce((total, message) => total + message.characterCount, 0)
      return totalCharacterCount
    } else {
      const userCharacterCount = filteredMessages.reduce((total, message) => total + message.characterCount, 0)
      const totalCharacterCount = userCharacterCount + latestMessage.length
      return { userCharacterCount, totalCharacterCount }
    }
  }

  const getImageFromGPT = async () => {
    if (!chatInput.replaceAll(/\s+/g, '')) {
      alert('タップして返信をかく の入力エリアにどのような画像を作成したいかを書いてからクリックしてね😊')
      return
    }
    const prompt = [
      {
        role: 'system',
        content: `次の文章を英訳して、英訳のみをレスポンスしてください。${chatInput}`
      }
    ]
    try {
      setIsStreaming(true)
      let res
      if (model && model.includes('azure')) {
        res = await getAzureGptMessage({ model, prompt: prompt })
      } else {
        res = await getGptMessage({ model, prompt: prompt })
      }
      setIsLoading(false)
      setIsGenerating(false)
      setIsStreaming(false)

      const { message } = res.data
      const imageURL = await getGptImage({ model, prompt: message, size: '256x256' })
      window.open(imageURL.data.image_url, '_blank')
    } catch (e) {
    } finally {
      setIsLoading(false)
      setGeneratingImage(false)
    }
  }
  // モーダルを開く関数
  const openModal = () => {
    setModalOpen(true)
  }

  // モーダルを閉じる関数
  const closeModal = () => {
    setModalOpen(false)
  }
  const [currentMessageData, setCurrentMessageData] = useState()
  const openModalForSubmission = (message) => {
    setCurrentMessageData(message && message)
    setIsModalOpenForSubmission(true)
    fetchSubmissionBoxes(user).catch(console.error)
  }
  const openModalForConversationSubmission = () => {
    setIsModalOpenForSubmission(true)
    fetchSubmissionBoxes(user).catch(console.error)
  }

  // モーダルを閉じる関数
  const closeModalForSubmission = () => {
    setIsModalOpenForSubmission(false)
  }

  useEffect(() => {
    if (!file) {
      setPreviewUrl(null)
      return
    }
    const fileReader = new FileReader()
    fileReader.onload = () => {
      setPreviewUrl(fileReader.result)
    }
    fileReader.readAsDataURL(file)
  }, [file]) // ファイルが変更されたときにプレビューを更新

  const removePreview = (indexToRemove, type) => {
    let fileType = ''
    if (type === 'image') {
      // 削除対象のプレビューURLを解放
      const urlToRemove = previewUrls[indexToRemove]
      URL.revokeObjectURL(urlToRemove)
      const newPreviewUrls = previewUrls.filter((_, index) => index !== indexToRemove)
      setPreviewUrls(newPreviewUrls)
      fileType = 'imageFiles'
    } else if (type === 'document') {
      fileType = 'documentFiles'
    } else {
      return
    }

    const _files = { ...files }
    _files[fileType] = _files[fileType].filter((_, index) => index !== indexToRemove)
    setFiles(_files)
    setHoveredPreviewIndexNumber(-1)
    setHoveredDocumentFileIndex(-1)
  }

  useEffect(() => {
    if (!userId || readOnly === false) return
    // 会話ログ・提出画面用
    const fetchConversations = async () => {
      let conversationsDocRef
      let originalConversationsDocRef
      let messagesCollectionRef
      // 提出
      if (window.location.pathname === '/submitted_conversations') {
        const userDocRef = doc(db, 'users', submitterUserId)

        conversationsDocRef = doc(userDocRef, conversationType, conversationId)
        originalConversationsDocRef = doc(
          userDocRef,
          conversationType,
          conversation.originalConversationId ? conversation.originalConversationId : conversationId
        )

        messagesCollectionRef = collection(
          db,
          `/externalServices/mingaku/schools/${schoolId}/submissionBoxes/${submittionBox}/submitters/${submitterUserId}/conversations/${conversationId}/messages`
        )
        const q = query(messagesCollectionRef, orderBy('createdAt', 'asc'))
        await getMessages(q, conversationsDocRef)
        const docSnapshotForAvator = await getDoc(originalConversationsDocRef)
        await updateAvatarImages(docSnapshotForAvator)
      } else {
        //  会話ログ
        const userDocRef = doc(db, 'users', userId)
        conversationsDocRef = doc(userDocRef, conversationType, conversationId)
        messagesCollectionRef = collection(conversationsDocRef, 'messages')
        const q = query(messagesCollectionRef, orderBy('createdAt', 'asc'))
        await getMessages(q, conversationsDocRef)
      }

      // setIsLoading(false)
    }
    // setIsLoading(true)
    fetchConversations()
    // eslint-disable-next-line
  }, [conversationId, conversationType, userId, submitterUserId])
  let replacedMessage2 = replacedMessage
  const [messageDocRef, setMessageDocRef] = useState(null)

  const startHandler = async () => {
    if (generatingImage) return
    const matchingModel = _gpt_model.find((item) => item.value === model)
    if (matchingModel.hasOwnProperty('streaming') && matchingModel.streaming !== true) {
      setIsStreaming(false)
    }
    setGeneratingImage(true)
    const lang = JSON.stringify(_language_list_v2[0])

    playTextSound('', selectedLanguage)
    const promptDocRef = doc(db, promptDocRefPath) // 渡されたpromptDocのfullPathからRefを作成
    setInitialPromptRef(promptDocRef)

    const role = _useAssistantApi ? 'user' : 'system'
    const userDocRef = doc(db, 'users', user.uid)
    const conversationsCollectionRef = collection(userDocRef, 'conversations')
    const conversationsDocRef = doc(conversationsCollectionRef)
    setNewConversationId(conversationsDocRef.id)

    const currentUrl = new URL(window.location)
    currentUrl.searchParams.set('conversation_id', conversationsDocRef.id)
    window.history.pushState({}, '', currentUrl)

    await setDoc(conversationsDocRef, {
      conversationId: conversationsDocRef.id,
      createdAt: new Date().getTime(),
      updatedAt: new Date().getTime(),
      model,
      promptRef: initialPromptRef
    })
    const messagesCollectionRef = collection(conversationsDocRef, 'messages')
    const systemMessageDocRef = doc(messagesCollectionRef)
    setMessageDocRef(systemMessageDocRef)
    console.log('①systemMessageDocRef', systemMessageDocRef)
    // 各オブジェクト内のkeyとvalueを使用してmessageを置き換える
    sentenceWordReplacementList.forEach((item) => {
      const placeholder = `{${item.key}}`
      const replacement = item.value ? item.value : `{${item.key}}`
      replacedMessage2 = replacedMessage2.replaceAll(placeholder, replacement)
    })
    const messagesForTokenCounter = [{ role: role, content: replacedMessage2 }]
    const { data } = await tokenCounter({
      text: replacedMessage2,
      role: role,
      model: model,
      messagesForTokenCounter: messagesForTokenCounter // 過去の会話履歴を含む
    })
    const { characterCount, tokenCount, tokenCountOfMessages } = data

    // 画像Inputがある場合、初回assistantがsystem promptに基づいた返信をするように、画像Inputを'user'で先に送る
    if (userInputValue && state.existingUserInputImages) {
      console.log('ユーザーインプットありかつ画像インプットあり')
      const groupedUserInputImageUrls = await uploadImagesToFirestore(conversationsDocRef.id, systemMessageDocRef.id)
      console.log('groupedUserInputImageUrls', groupedUserInputImageUrls)
      const additionalInitialMessagePromises = Object.entries(groupedUserInputImageUrls).map(
        async ([questionKey, images]) => {
          if (images.length === 0) {
            console.log(`No valid images for question ${questionKey}. Skipping setDoc.`)
            return
          }

          // userInputValueからquestionKeyに一致するオブジェクトのvalueを取得
          const question = userInputValue.find((input) => input.key === questionKey)
          const questionValue = question ? question.value : ''
          // ファイル名をカンマ区切りで連結
          const fileNames = images.map((img) => img.fileName || img.title).join(', ')

          // テキストメッセージを作成
          const message = [
            {
              type: 'text',
              text: `【画像名】${fileNames}\n【画像の説明】${questionValue}`
            },
            ...images.map((img) => ({
              type: 'image_url',
              image_url: {
                url: img.downloadURL
              }
            }))
          ]

          const targetDocRef = doc(messagesCollectionRef) // 初回のみsystemMessageDocRefを使用
          console.log('②targetDocRef', targetDocRef)

          await setDoc(targetDocRef, {
            messageId: targetDocRef.id,
            message,
            role: 'user',
            model,
            createdAt: new Date().getTime(),
            characterCount,
            tokenCount,
            tokenCountOfMessages,
            actualMessageLength: message.length,
            hide: true,
            imageQuestionKey: questionKey
          })
        }
      )

      await Promise.all(additionalInitialMessagePromises)

      console.log('★userInputValue', userInputValue)
      console.log('★groupedUserInputImageUrls', groupedUserInputImageUrls)

      const updatedUserInputValue = userInputValue.map((item) => {
        const matchingImages = groupedUserInputImageUrls[item.key] || []

        if (item.type === 'image' && matchingImages.length > 0) {
          return {
            ...item,
            files: matchingImages.map((img) => ({
              url: img.downloadURL, // URL
              fileName: img.fileName // ファイル名
            })) // 配列にURLとファイル名を追加
          }
        }
        return item
      })

      console.log('③systemMessageDocRef', systemMessageDocRef.id, systemMessageDocRef)
      // システムプロンプトの内容
      await setDoc(systemMessageDocRef, {
        messageId: systemMessageDocRef.id,
        message: replacedMessage2,
        role: 'user', //'system'
        model,
        createdAt: new Date().getTime(),
        bubbleForSystem: true,
        userInput: true,
        userInputValue: updatedUserInputValue,
        characterCount,
        tokenCount,
        tokenCountOfMessages, // 過去の会話履歴を含む
        actualMessageLength: replacedMessage2.length,
        hide: true
      })
    } else if (userInputValue) {
      console.log('ユーザーインプットあり')
      await setDoc(systemMessageDocRef, {
        messageId: systemMessageDocRef.id,
        message: replacedMessage2,
        role: 'system', //'system'
        model,
        createdAt: new Date().getTime(),
        userInput: true,
        userInputValue,
        characterCount,
        tokenCount,
        tokenCountOfMessages, // 過去の会話履歴を含む
        actualMessageLength: replacedMessage2.length,
        hide: false
      })
    } else {
      console.log('ユーザーインプットなし')
      await setDoc(systemMessageDocRef, {
        messageId: systemMessageDocRef.id,
        message: replacedMessage2,
        role: 'system', //'system'
        model,
        createdAt: new Date().getTime(),
        characterCount,
        tokenCount,
        tokenCountOfMessages, // 過去の会話履歴を含む
        actualMessageLength: replacedMessage2.length,
        hide: false
      })
    }

    _setStart(true)
    onStartChange(true)
    _setStartButton(false)
    setGeneratingImage(false)
  }

  const initialUserData = _fields_of_user_data_in_mypage.reduce((mypageData, field) => {
    mypageData[field.value] = ''
    return mypageData
  }, {})

  const [userDataOfMypage, setUserDataOfMypage] = useState(initialUserData)
  const handleUserDataChange = (updates) => {
    setUserDataOfMypage((prevData) => ({
      ...prevData,
      ...updates
    }))
  }
  useEffect(() => {
    if (readOnly === true) return
    let replacementList = []
    ;(async () => {
      if (_start === false && _startButton === true) {
        setGeneratingImage(true)
        if (!!state.userInputValue) {
          replacementList = [...state.userInputValue]
        }
        const userDocRef = doc(db, 'users', user ? user.uid : state.uid)
        const userSnapshot = await getDoc(userDocRef)
        const userData = userSnapshot.data()
        // ここで名前とスクール名などすべて取得
        let mingakuUserData
        if (!!userData.studentDocId || userData.role === 'tutor') {
          const { mingakuData, schoolAiData } = await updateUserData(userSnapshot)
          mingakuUserData = { ...mingakuData, ...schoolAiData }
          handleUserDataChange(mingakuUserData)
        } else {
          const { mingakuUserId, email } = userSnapshot.data()
          if (mingakuUserId === undefined) {
            alert(
              'このアカウントはみんがくアカウントと連携されてません。連携を完了させるために、みんがく管理画面のスクールAI管理からスクールAIにアクセスしてください。(全ての機能を利用するためには、みんがくアカウントとの連携が必要です。)'
            )
          } else {
            mingakuUserData = await getUserDataFromMingaku(userSnapshot)
            handleUserDataChange(mingakuUserData)
          }
        }
        const fixedMingakuUserData = Object.entries(mingakuUserData).map(([key, value]) => ({
          title: `${key}`,
          key: `${key}`,
          value: value
        }))
        const mypageUserData = Object.entries(mingakuUserData).map(([key, value]) => ({
          title: `${key}.mypage`,
          key: `${key}.mypage`,
          value: value
        }))
        replacementList = [...replacementList, ...fixedMingakuUserData, ...mypageUserData]

        if (userData.type === 'mingaku' && !!userData.studentDocId) {
          const getStudentInfo = httpsCallable(functions, 'get_student_info_of_mingaku')
          const getSchoolsInfo = httpsCallable(functions, 'get_schools_info')
          const [studentInfo, schoolInfo] = await Promise.all([
            getStudentInfo({ nandeUserId: user ? user.uid : state.uid }),
            getSchoolsInfo({ schoolIds: [userData.schoolDocId] })
          ])

          const customProperties = schoolInfo.data.schoolInfo[0].customProperties

          if (customProperties.length !== 0) {
            const studentProperties = studentInfo.data.data.properties
            const studentCustomPropertiesReplacementList = customProperties.map((item) => {
              const foundProperty = studentProperties.find((studentProperty) => studentProperty.id === item.id)
              return {
                title: item.title,
                key: item.title, // customPropertiesは物理名を持っていないため論理名(title)をKeyとする
                value: foundProperty ? foundProperty.value : ''
              }
            })

            replacementList = [...replacementList, ...studentCustomPropertiesReplacementList]
          }
          const studentInfoReplacementList = _inserted_default_target_student_info.map((item) => {
            const value = studentInfo.data.data[item.key]
            return {
              title: item.title,
              key: item.key,
              value
            }
          })

          replacementList = [...replacementList, ...studentInfoReplacementList]
        } else if (userData.type === 'mingaku' && userData.role === 'tutor') {
          const getSchoolsInfo = httpsCallable(functions, 'get_schools_info')
          const schoolInfo = await getSchoolsInfo({ schoolIds: [userData.schoolDocId] })
          const customProperties = schoolInfo.data.schoolInfo[0].customProperties
          if (customProperties.length !== 0) {
            const studentCustomPropertiesReplacementList = customProperties.map((item) => {
              return {
                title: item.title,
                key: item.title, // customPropertiesは物理名を持っていないため論理名(title)をKeyとする
                value: '' // tutorの場合は空にする
              }
            })
            replacementList = [...replacementList, ...studentCustomPropertiesReplacementList]
          }
          const studentInfoReplacementList = _inserted_default_target_student_info.map((item) => {
            return {
              title: item.title,
              key: item.key,
              value: '' // tutorの場合は空にする
            }
          })
          replacementList = [...replacementList, ...studentInfoReplacementList]
        }
        setSentenceWordReplacementList(replacementList)
        setGeneratingImage(false)
      }
    })()
    // eslint-disable-next-line
  }, [_start, _startButton])

  useEffect(() => {
    if (readOnly === true) return
    if (promptDocRefPath !== undefined) {
      const promptDocRef = doc(db, promptDocRefPath) // 渡されたpromptDocのfullPathからRefを作成
      setInitialPromptRef(promptDocRef)
    }
    // eslint-disable-next-line
  }, [promptDocRefPath])

  useEffect(() => {
    if (readOnly === true) return

    isFirstRender.current = true
    let localIsMute = isMute ? 1 : 0
    localStorage.setItem('localIsMute', localIsMute)
    // eslint-disable-next-line
  }, [isMute])

  useEffect(() => {
    if (readOnly === true) return

    if (finalTranscript !== '') {
      // 入力完了後
      setChatInput(previousChatInput + finalTranscript)
      if (islistening) {
        chatInput.replaceAll(/\s+/g, '') !== '' && autoSending && onTextInput()
      }
      setIsListening(false)
      SpeechRecognition.stopListening()
    } else {
      // 入力中
      setChatInput(previousChatInput + transcript)
    }
    // eslint-disable-next-line
  }, [interimTranscript, finalTranscript])

  const [newConversationsDocRef, setNewConversationsDocRef] = useState()
  useEffect(() => {
    if (readOnly === true) return
    if (_audio) {
      _audio.pause()
    }
    setIsMute(defaultMute)
    if (state) {
      sessionStorage.setItem('redirectPageUrl', state.redirectPageUrl)
    }

    if (isFirstRender.current && _startButton === true) {
      isFirstRender.current = false
    } else {
      const fetchConversations = async () => {
        if (!user || !user.uid) {
          return
        } // userがnullまたはundefinedの場合、早期リターン
        const userDocRef = doc(db, 'users', user.uid)

        const conversationsDocRef = doc(
          userDocRef,
          conversationType,
          conversationId ? conversationId : newConversationId
        )
        localStorage.setItem('reloadConversationId', conversationId ? conversationId : state.conversationId)

        const messagesCollectionRef = collection(conversationsDocRef, 'messages')
        const q = query(messagesCollectionRef, orderBy('createdAt', 'asc'))

        try {
          setNewConversationsDocRef(conversationsDocRef)

          await getMessages(q, conversationsDocRef)
          await getPromptTitle(conversationsDocRef)
          setIsLoading(false)
          // setIsBubbleLoading(false)
        } catch (error) {
          console.error('Error fetching conversation data: ', error)
        }
      }
      if (user && user.uid) {
        setIsLoading(true)
        fetchConversations() // user と user.uid が存在する場合のみ fetchConversations を呼び出す
      }
    }
    // eslint-disable-next-line
  }, [_start, user, conversationId])

  useEffect(() => {
    ;(async () => {
      if (!_start && !_startButton) {
        let replacementList = []
        if (!!conversation.userInputValue) {
          replacementList = [...conversation.userInputValue]
        }
        const userDocRef = doc(db, 'users', user ? user.uid : state.uid)
        const userSnapshot = await getDoc(userDocRef)
        const userData = userSnapshot.data()
        // ここで名前とスクール名などすべて取得
        let mingakuUserData
        if (!!userData.studentDocId || userData.role === 'tutor') {
          const { mingakuData, schoolAiData } = await updateUserData(userSnapshot)
          mingakuUserData = { ...mingakuData, ...schoolAiData }
          handleUserDataChange(mingakuUserData)
        } else {
          const { mingakuUserId, email } = userSnapshot.data()
          if (mingakuUserId === undefined) {
            alert(
              'このアカウントはみんがくアカウントと連携されてません。連携を完了させるために、みんがく管理画面のスクールAI管理からスクールAIにアクセスしてください。(全ての機能を利用するためには、みんがくアカウントとの連携が必要です。)'
            )
          } else {
            mingakuUserData = await getUserDataFromMingaku(userSnapshot)
            handleUserDataChange(mingakuUserData)
          }
        }
        const fixedMingakuUserData = Object.entries(mingakuUserData).map(([key, value]) => ({
          title: `${key}`,
          key: `${key}`,
          value: value
        }))
        const mypageUserData = Object.entries(mingakuUserData).map(([key, value]) => ({
          title: `${key}.mypage`,
          key: `${key}.mypage`,
          value: value
        }))
        replacementList = [...replacementList, ...fixedMingakuUserData, ...mypageUserData]

        if (userData.type === 'mingaku' && !!userData.studentDocId) {
          const getStudentInfo = httpsCallable(functions, 'get_student_info_of_mingaku')
          const getSchoolsInfo = httpsCallable(functions, 'get_schools_info')
          const [studentInfo, schoolInfo] = await Promise.all([
            getStudentInfo({ nandeUserId: user ? user.uid : state.uid }),
            getSchoolsInfo({ schoolIds: [userData.schoolDocId] })
          ])

          const customProperties = schoolInfo.data.schoolInfo[0].customProperties

          if (customProperties.length !== 0) {
            const studentProperties = studentInfo.data.data.properties
            const studentCustomPropertiesReplacementList = customProperties.map((item) => {
              const foundProperty = studentProperties.find((studentProperty) => studentProperty.id === item.id)
              return {
                title: item.title,
                key: item.title, // customPropertiesは物理名を持っていないため論理名(title)をKeyとする
                value: foundProperty ? foundProperty.value : ''
              }
            })

            replacementList = [...replacementList, ...studentCustomPropertiesReplacementList]
          }
          const studentInfoReplacementList = _inserted_default_target_student_info.map((item) => {
            const value = studentInfo.data.data[item.key]
            return {
              title: item.title,
              key: item.key,
              value
            }
          })

          replacementList = [...replacementList, ...studentInfoReplacementList]
        } else if (userData.type === 'mingaku' && userData.role === 'tutor') {
          const getSchoolsInfo = httpsCallable(functions, 'get_schools_info')
          const schoolInfo = await getSchoolsInfo({ schoolIds: [userData.schoolDocId] })
          const customProperties = schoolInfo.data.schoolInfo[0].customProperties
          if (customProperties.length !== 0) {
            const studentCustomPropertiesReplacementList = customProperties.map((item) => {
              return {
                title: item.title,
                key: item.title, // customPropertiesは物理名を持っていないため論理名(title)をKeyとする
                value: '' // tutorの場合は空にする
              }
            })
            replacementList = [...replacementList, ...studentCustomPropertiesReplacementList]
          }
          const studentInfoReplacementList = _inserted_default_target_student_info.map((item) => {
            return {
              title: item.title,
              key: item.key,
              value: '' // tutorの場合は空にする
            }
          })
          replacementList = [...replacementList, ...studentInfoReplacementList]
        }
        setSentenceWordReplacementList(replacementList)
      }
    })()
  }, [conversation])
  const updateAvatarImages = async (docSnapshot) => {
    if (!!docSnapshot.data() && !!docSnapshot.data().promptRef) {
      const initialPromptRef = docSnapshot.data().promptRef
      const aaa = await getDoc(initialPromptRef)
      let avatorImages = [ai, ai2]
      if (aaa.data() !== undefined && !!aaa.data().iconImageUrl && !!aaa.data().iconImageUrl2) {
        avatorImages = [aaa.data().iconImageUrl, aaa.data().iconImageUrl2]
        setAvatorImages(avatorImages)
      } else if (aaa.data() !== undefined && (!!aaa.data().iconImageUrl || !!aaa.data().iconImageUrl2)) {
        const imageUrl = aaa.data().iconImageUrl ? aaa.data().iconImageUrl : aaa.data().iconImageUrl2
        avatorImages = [imageUrl, imageUrl]
        setAvatorImages(avatorImages)
      } else {
        setAvatorImages(avatorImages)
      }
    }
  }
  const getMessages = async (q, conversationsDocRef) => {
    console.log('getMessages実行')
    const messageModel = model
    const matchingModel = _gpt_model.find((item) => item.value === messageModel)
    // console.log('matchingModel', matchingModel)
    const docSnapshot = await getDoc(conversationsDocRef)
    if (window.location.pathname !== '/submitted_conversations') {
      await updateAvatarImages(docSnapshot)
    }
    const querySnapshot = await getDocs(q)
    console.log(querySnapshot.docs.length)
    const chatMessages = querySnapshot.docs.map((doc) => {
      let content = doc.data().message
      // If matchingModel exists and availableVision is false, filter the content array if it is an array
      if (matchingModel && !matchingModel.availableVision && Array.isArray(content)) {
        content = content.filter((item) => item.type === 'text')
      }
      return {
        // content: doc.data().message,
        content: content,
        displayMessage: doc.data().displayMessage,
        role: doc.data().role ? doc.data().role : 'system',
        messageTime: doc.data().createdAt,
        model: doc.data().model,
        userInput: doc.data().userInput,
        userInputValue: doc.data().userInputValue,
        characterCount: doc.data().characterCount ?? '',
        readDone: true,
        messageId: doc.data().messageId,
        tokenCountOfMessages: doc.data().tokenCountOfMessages,
        actualMessageLength: doc.data().actualMessageLength,
        tokenCount: doc.data().tokenCount,
        hide: doc.data().hide ?? false,
        ref: doc.ref,
        imageQuestionKey: doc.data().imageQuestionKey ?? '',
        bubbleForSystem: doc.data().bubbleForSystem ?? false,
        docFiles: doc.data().docFiles ?? [],
        excelContents: doc.data().excelContents ?? '',
        factCheckResult: doc.data().factCheckResult ?? ''
      }
    })

    if (querySnapshot.docs.length > 0) {
      const docsData = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        ref: doc.ref
      }))

      if (docsData[0]?.role === 'system') {
        console.log('①', docsData[0].ref)
        setMessageDocRef(docsData[0].ref)
      } else {
        // Find the document where bubbleForSystem is true
        const systemMessage = docsData.find((doc) => doc.bubbleForSystem === true)

        if (systemMessage) {
          // Find the index of the system message in the original querySnapshot.docs array
          const systemMessageIndex = docsData.indexOf(systemMessage)
          if (systemMessageIndex !== -1) {
            console.log('②', docsData[systemMessageIndex])
            setMessageDocRef(docsData[systemMessageIndex].ref)
          } else {
            console.error('System message found but index is invalid.')
          }
        } else {
          console.log('No system message object found.')
        }
      }
    } else {
      console.log('No documents in querySnapshot.')
    }

    if (readOnly === true) {
      // 読み取り専用会話ログ画面用
      setChatData([...chatMessages])
    } else if (readOnly === false) {
      let isStreamingModel = true
      if (matchingModel?.hasOwnProperty('streaming') && matchingModel?.streaming !== true) {
        isStreamingModel = false
      }
      // ホーム画面・チャット画面用
      const lastChatMessage = chatMessages[chatMessages.length - 1]
      const { role, model } = lastChatMessage
      if (role === 'assistant') {
        const docSnapshot = await getDoc(conversationsDocRef)
        let lang = ''
        if (!!docSnapshot.data().promptRef) {
          const initialPromptRef = docSnapshot.data().promptRef
          const prompt_data = await getDoc(initialPromptRef)
          if (!!prompt_data.data()) {
            const responceOptions =
              prompt_data.data().responseOptions?.length !== 0 ? prompt_data.data().responseOptions : _responseOptions
            const sortedResponceOptions = responceOptions.sort(function (a, b) {
              return a.order < b.order ? -1 : 1
            })

            const matchingLanguage = getMatchingLanguage(prompt_data.data().prompt_language2)
            lang = matchingLanguage ? JSON.stringify(matchingLanguage) : JSON.stringify(_language_list_v2[0])
            setPromptData(prompt_data.data())
            setSelectedLanguage(lang)
            setResponseOptions(
              sortedResponceOptions.map((item) => {
                return { option: item.option, content: item.content ? item.content : item.option }
              })
            )
          }
        }
      }
      if (role === 'user' || role === 'system') {
        const prompt = chatMessages.map((item) => {
          return {
            role: item.role,
            content: item.content
          }
        })
        setIsLoading(true)

        const docSnapshot = await getDoc(conversationsDocRef)

        let lang = ''
        if (!!docSnapshot.data().promptRef) {
          const initialPromptRef = docSnapshot.data().promptRef
          const prompt_data = await getDoc(initialPromptRef)

          if (!!prompt_data.data()?.responseOptions) {
            const responceOptions =
              prompt_data.data().responseOptions?.length !== 0 ? prompt_data.data().responseOptions : _responseOptions
            const sortedResponceOptions = responceOptions.sort(function (a, b) {
              return a.order < b.order ? -1 : 1
            })

            const matchingLanguage = getMatchingLanguage(prompt_data.data().prompt_language2)
            lang = matchingLanguage ? JSON.stringify(matchingLanguage) : JSON.stringify(_language_list_v2[0])
            setPromptData(prompt_data.data())
            setSelectedLanguage(lang)
            setResponseOptions(
              sortedResponceOptions.map((item) => {
                return { option: item.option, content: item.content ? item.content : item.option }
              })
            )
          }
        }

        setIsGenerating(true)
        if (isStreamingModel) {
          if (_useAssistantApi) {
            let success
            if (model && model.includes('azure')) {
              success = await createThreadAndRunForAzure({ pastContent: chatMessages })
            } else {
              // success = await createThreadAndRun({ pastContent: chatMessages })
            }
            if (!success) {
              _setUseAssistantApi(null)
              await getGptStreamResponse({ model, prompt, pastContent: chatMessages, temperature })
            }
          } else {
            await getGptStreamResponse({ model, prompt, pastContent: chatMessages, temperature })
          }
        } else {
          setIsStreaming(true)
          let res
          if (model && model.includes('azure')) {
            res = await getAzureGptMessage({ model, prompt: prompt })
          } else {
            res = await getGptMessage({ model, prompt: prompt })
          }
          const { message } = res.data
          setTimeout(function () {
            playTextSound(message, lang)
          }, 1000)
          const gptChatMessage = {
            role: 'assistant',
            content: message,
            messageTime: new Date().getTime(),
            characterCount: message.length,
            actualMessageLength: message.length
          }
          const messagesForTokenCounter = [{ role: gptChatMessage.role, content: gptChatMessage.content }]
          addMessageToDB(gptChatMessage, '', messagesForTokenCounter)
          setChatData([...chatMessages, ...[gptChatMessage]])
        }
        setIsLoading(false)
        setIsGenerating(false)
        setIsStreaming(false)
      } else {
        setChatData([...chatMessages])
      }
    }
  }

  const formatCurrentDate = () => {
    const now = new Date()
    const year = now.getFullYear() // 年を取得
    const month = (now.getMonth() + 1).toString().padStart(2, '0') // 月を取得（getMonth()は0から始まるため+1する）
    const day = now.getDate().toString().padStart(2, '0') // 日を取得
    const hours = now.getHours().toString().padStart(2, '0') // 時を取得
    const minutes = now.getMinutes().toString().padStart(2, '0') // 分を取得
    const seconds = now.getSeconds().toString().padStart(2, '0') // 秒を取得

    return `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`
  }
  const [anchorEl, setAnchorEl] = useState(null)
  const cleanMessageData = (data) => {
    const cleanedData = {}
    Object.keys(data).forEach((key) => {
      if (data[key] !== undefined) {
        if (key === 'messageTime') {
          // messageTimeがあればcreatedAtとしてセット
          cleanedData['createdAt'] = data[key]
        }
        if (key === 'content') {
          // messageTimeがあればcreatedAtとしてセット
          cleanedData['message'] = data[key]
        } else {
          // それ以外のundefinedでない値をコピー
          cleanedData[key] = data[key]
        }
      }
    })
    return cleanedData
  }

  const getToturName = async (userDocData) => {
    if (userDocData.role === 'tutor') {
      const { schoolDocId, tutorDocId } = userDocData
      const getTutorInfo = httpsCallable(functions, 'get_tutor_info_of_mingaku')
      const getSchoolsInfo = httpsCallable(functions, 'get_schools_info')
      const [tutorIndo, schoolInfo] = await Promise.all([
        getTutorInfo({ userId: tutorDocId, schoolId: schoolDocId }),
        getSchoolsInfo({ schoolIds: [schoolDocId] })
      ])
      return `先生用 | ${tutorIndo.data.tutorDocData.name}`
    } else {
      return '先生アカウント'
    }
  }
  const submissionConversation = async (item) => {
    const userDocRef = doc(db, 'users', user ? user.uid : state.uid)
    const userSnapshot = await getDoc(userDocRef)
    const submitterRef = doc(item.ref, 'submitters', user.uid)
    const submitterSnapshot = await getDoc(submitterRef)
    const tutorName = await getToturName(userSnapshot.data())
    const submitterData = {
      userId: user.uid,
      userName: userSnapshot.data().name
        ? userSnapshot.data().name
        : (userSnapshot.data() && userSnapshot.data().lastName) ||
          (userSnapshot.data() && userSnapshot.data().firstName)
        ? userSnapshot.data().lastName + ' ' + userSnapshot.data().firstName
        : userSnapshot.data().schoolDocId
        ? tutorName
        : 'みんがく管理人',
      schoolId: userSnapshot.data() && userSnapshot.data().schoolDocId ? userSnapshot.data().schoolDocId : '',
      submittedAt: new Date().getTime()
    }

    if (!submitterSnapshot.exists()) {
      await setDoc(submitterRef, submitterData)
    } else {
      await updateDoc(submitterRef, submitterData)
    }
    // 'submitters'の下に提出する会話のドキュメントを作成）
    const idForNewLocationRef = conversationId ? conversationId : newConversationId

    const newLocationRef = doc(
      item.ref,
      'submitters',
      user.uid,
      'conversations',
      `${idForNewLocationRef}_${new Date().getTime()}`
    )
    // 元のconversationsDocRefドキュメントを取得
    const conversationsDoc = await getDoc(
      conversation.conversationDocRef ? conversation.conversationDocRef : newConversationsDocRef
    )

    if (currentMessageData) {
      // メッセージのみの提出
      const cleanedData = cleanMessageData(currentMessageData)
      const batch = writeBatch(db)

      // 新しい場所にconversationsDocRefのデータをコピー
      batch.set(newLocationRef, conversationsDoc.data())
      await batch.commit()

      const newMessageRef = doc(collection(newLocationRef, 'messages'))

      await setDoc(newMessageRef, cleanedData) // cleanedDataを使用してsetDocを呼び出し

      await updateDoc(newLocationRef, {
        submittedAt: new Date().getTime(),
        submission_title: `提出_${conversation.mode}_${formatCurrentDate()}`,
        type: currentMessageData ? 'message' : 'conversation'
      })
      alert(`${item.submission_box_title}に提出しました！`)
      setIsModalOpenForSubmission(false)
      setAnchorEl(null)
    } else if (conversationsDoc.exists()) {
      // 会話全体の提出
      // writeBatchを使用して複数の書き込み操作を一度に行う
      const batch = writeBatch(db)

      // 新しい場所にconversationsDocRefのデータをコピー
      batch.set(newLocationRef, conversationsDoc.data())

      // // 元のmessagesサブコレクションを取得
      const messagesRef = collection(
        conversation.conversationDocRef ? conversation.conversationDocRef : newConversationsDocRef,
        'messages'
      )
      const messageDocs = await getDocs(messagesRef)

      // // 各messagesドキュメントを新しい場所にコピー
      messageDocs.forEach((docSnapshot) => {
        // 新しいメッセージドキュメントの参照を自動生成された ID で作成
        const newMessageRef = doc(collection(newLocationRef, 'messages'))
        // 新しいメッセージドキュメントにデータをセット
        batch.set(newMessageRef, docSnapshot.data())
      })

      // // バッチ操作をコミット
      await batch.commit()

      // conversationドキュメント更新
      await updateDoc(newLocationRef, {
        submittedAt: new Date().getTime(),
        submission_title: `提出_${conversation.mode}_${formatCurrentDate()}`,
        type: currentMessageData ? 'message' : 'conversation'
      })
      alert(`${item.submission_box_title}に提出しました！`)
      setIsModalOpenForSubmission(false)
      setAnchorEl(null)
    } else {
    }
    setCurrentMessageData()
  }

  const getPromptTitle = async (conversationsDocRef) => {
    const aaa = await getDoc(conversationsDocRef)

    const promptDoc = await getDoc(aaa.data().promptRef)

    if (
      promptDoc.data() !== undefined &&
      promptDoc.data().character_limit === true &&
      promptDoc.data().maximum_character_count
    ) {
      setCharacterLimit(true)
      setMaxCharacters(promptDoc.data().maximum_character_count)
    } else {
      setCharacterLimit(false)
      setMaxCharacters(0)
    }
    if (
      promptDoc.data() !== undefined &&
      promptDoc.data().character_limit_per_month === true &&
      promptDoc.data().maximum_character_count_per_month
    ) {
      setCharacterLimitPerMonth(true)
      setMaxCharactersPerMonth(promptDoc.data().maximum_character_count_per_month)
    } else {
      setCharacterLimitPerMonth(false)
      setMaxCharactersPerMonth(0)
    }

    if (
      promptDoc.data() !== undefined &&
      promptDoc.data().sending_count_limit === true &&
      promptDoc.data().maximum_sending_count_limit
    ) {
      setIsSendingCountLimitSet(true)
      setMaximumSendingCountLimit(promptDoc.data().maximum_sending_count_limit)
    } else {
      setIsSendingCountLimitSet(false)
      setMaximumSendingCountLimit(0)
    }

    if (
      promptDoc.data() !== undefined &&
      promptDoc.data().is_past_message_limit_count_set === true &&
      promptDoc.data().maximum_past_message_limit_count
    ) {
      setIsPastMessageLimitCountSet(true)
      setMaximumPastMessageLimitCount(promptDoc.data().maximum_past_message_limit_count)
    } else {
      setIsPastMessageLimitCountSet(false)
      setMaximumPastMessageLimitCount(0)
    }
  }
  const [submissionBoxes, setSubmissionBoxes] = useState([])
  const fetchSubmissionBoxes = async (user) => {
    if (user) {
      let paramSchoolId

      const userDocRef = doc(db, 'users', user.uid)
      await getDoc(userDocRef).then(async (userDocSnapshot) => {
        if (userDocSnapshot.exists()) {
          const userData = userDocSnapshot.data()
          paramSchoolId = userData.schoolDocId
        }
      })

      let promptDocRef
      if (paramSchoolId) {
        const mingakuDocRef = doc(db, 'externalServices', 'mingaku')
        const schoolsCollectionRef = collection(mingakuDocRef, 'schools')
        promptDocRef = doc(schoolsCollectionRef, paramSchoolId)
      } else {
        promptDocRef = doc(db, 'service_type', 'gpt-teacher')
      }

      const propmts_q = query(collection(promptDocRef, 'submissionBoxes'))
      const querySnapshot = await getDocs(propmts_q)
      let submissionBoxesData = await Promise.all(
        querySnapshot.docs.map(async (doc) => {
          return {
            submission_box_title: doc.data().submission_box_title ? doc.data().submission_box_title : '',
            enable: doc.data().enable,
            id: doc.id,
            ref: doc.ref,
            updatedAt: doc.data().updatedAt ? doc.data().updatedAt : '',
            editable: true
          }
        })
      )

      let enabledSubmissionBoxesData = submissionBoxesData.filter((item) => item.enable === true)

      if (enabledSubmissionBoxesData.length !== 0) {
        const results = enabledSubmissionBoxesData.sort((a, b) => (a.updatedAt > b.updatedAt ? -1 : 1))
        setSubmissionBoxes(results)
      }
    }
  }

  useEffect(() => {
    const container = containerRef.current
    if (container) {
      const scrollHeight = container.scrollHeight
      const start = container.scrollTop
      const change = scrollHeight - start + 1500
      const increment = 20 // スクロール速度の設定（調整可）
      let currentTime = 0
      const animateScroll = () => {
        currentTime += increment
        const easing = easeInOutQuad(currentTime, start, change, 2500) // イージング関数の適用（調整可）
        container.scrollTop = easing
        if (currentTime < 2500) {
          requestAnimationFrame(animateScroll)
        }
      }
      animateScroll()
    }
  }, [chatData.length, isLoading])

  useEffect(() => {
    return () => stopPlaying()
  }, [])

  const startOverHandler = (e) => {
    e.stopPropagation()
    // 確認ダイアログを表示
    const isConfirmed = window.confirm('本当に会話をやり直しますか？')

    // ユーザーがOKを選択した場合、画面をリロード
    if (isConfirmed) {
      if (_audio) {
        _audio.pause()
      }
      const _redirectUrl = sessionStorage.getItem('redirectPageUrl')

      navigate(`${_redirectUrl}`, {})
    }
  }
  const [largeIconAvatorWidth, setLargeIconAvatorWidth] = useState(0)
  useEffect(() => {
    // chat-screen の位置を更新する関数
    const updateChatScreenPosition = () => {
      if (avatorContainerRef.current) {
        setLargeIconAvatorWidth(avatorContainerRef.current.offsetHeight - 16)
      }
    }

    // コンポーネントのマウント時とウィンドウのリサイズ時に実行
    updateChatScreenPosition()
    window.addEventListener('resize', updateChatScreenPosition)
    return () => window.removeEventListener('resize', updateChatScreenPosition)
  }, [isLargeIcon, _start, isLoading])

  const handleKeyDown = (event) => {
    if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
      if (!islistening && !isLoading && !isGenerating && chatInput) {
        onTextInput()
      } else {
      }
    }
  }

  const handleUserInputChange = async (newUserInputValue) => {
    // console.log('handleUserInputChange実行newUserInputValue', newUserInputValue)

    setChatData((prevChatData) => {
      const updatedChatData = [...prevChatData]
      // userInputValueはChatBubbleForSystemに表示される項目(みんがくデータとマイページデータは表示されません)
      // 0番目がrole='system'であればこの方法でOK
      // if (updatedChatData[0].role == 'system') {
      //   updatedChatData[0].userInputValue = newUserInputValue
      // }

      let newContent = promptData.prompt
      promptData.formQuestions.forEach((question) => {
        const userInput = newUserInputValue.find((item) => item.key === question.key)

        if (userInput) {
          newContent = newContent.replace(`{${question.key}}`, userInput.value)
          // Replace {key.length} with the length of the input value
          const lengthPlaceholder = `{${question.key}.length}`
          if (newContent.includes(lengthPlaceholder)) {
            newContent = newContent.replace(lengthPlaceholder, userInput.value.length.toString())
          }
        }
      })

      // Step 2: Further replace using sentenceWordReplacementList(みんがくデータやマイページデータの変換)
      const uniqueKeysInReplacementList = sentenceWordReplacementList.filter(
        (replacement) => !newUserInputValue.some((input) => input.key === replacement.key)
      )

      uniqueKeysInReplacementList.forEach((replacement) => {
        newContent = newContent.replace(`{${replacement.key}}`, replacement.value)

        const lengthPlaceholder = `{${replacement.key}.length}`
        if (newContent.includes(lengthPlaceholder)) {
          newContent = newContent.replace(lengthPlaceholder, replacement.value.length.toString())
        }
      })

      if (updatedChatData[0].role == 'system') {
        updatedChatData[0].userInputValue = newUserInputValue
        updatedChatData[0].content = newContent
      } else {
        const itemForUpdate = updatedChatData.find((item) => item.bubbleForSystem === true)

        if (itemForUpdate) {
          // 該当するオブジェクトのインデックス
          const indexForUpdate = updatedChatData.indexOf(itemForUpdate)
          // コンソールに出力
          console.log('Found Index:', indexForUpdate)
          console.log('Found Object:', itemForUpdate)
          updatedChatData[indexForUpdate].userInputValue = newUserInputValue
          updatedChatData[indexForUpdate].content = newContent
        } else {
          console.log('No object with bubbleForSystem set to true found.')
        }
      }

      return updatedChatData
    })

    console.log('messageDocRef', messageDocRef.id, messageDocRef)
    if (messageDocRef) {
      try {
        if (chatData[0].role == 'system') {
          await updateDoc(messageDocRef, {
            userInputValue: newUserInputValue,
            message: chatData[0].content
          })
        } else {
          const itemForUpdate = chatData.find((item) => item.bubbleForSystem === true)
          if (itemForUpdate) {
            // 該当するオブジェクトのインデックス
            const indexForUpdate = chatData.indexOf(itemForUpdate)
            await updateDoc(messageDocRef, {
              userInputValue: newUserInputValue,
              message: chatData[indexForUpdate].content
            })
          } else {
            console.log('No object with bubbleForSystem set to true found.')
          }
        }
      } catch (error) {
        console.error('Error updating Firestore document:', error)
      }
    }
  }
  const [userInputImageFiles, setUserInputImageFiles] = useState(state?.userInputImages)
  const uploadImagesToFirestore = async (conversationId, messageId) => {
    console.log('userInputImageFiles', userInputImageFiles)

    const groupedImages = {}

    await Promise.all(
      userInputImageFiles.map(async (imageData) => {
        console.log('userInputImageFiles', userInputImageFiles)
        if (imageData && imageData.files.length > 0) {
          console.log(`Processing images for question: ${imageData.key}`, imageData.files)

          const uploadedImages = await Promise.all(
            imageData.files.map(async (fileData, index) => {
              console.log(`Checking fileData for key ${imageData.key}, index ${index}:`, fileData)

              if (!fileData.file || !(fileData.file instanceof File)) {
                console.error(`Invalid file object for key ${imageData.key}:`, fileData.file)
                return null
              }

              const iconImagePath = `conversationPictures/${user.uid}/${conversationId}/${messageId}/${
                fileData.file.name + uuid()
              }`
              const storageRef = ref(storage, iconImagePath)

              try {
                await uploadBytes(storageRef, fileData.file)
                const downloadURL = await getDownloadURL(storageRef)
                return {
                  downloadURL,
                  key: imageData.key,
                  title: imageData.title,
                  fileName: fileData.file.name
                }
              } catch (error) {
                console.error(`Failed to upload file for key ${imageData.key}:`, error)
                return null
              }
            })
          )

          groupedImages[imageData.key] = uploadedImages.filter((img) => img !== null)
        }
      })
    )

    console.log('Grouped Images:', groupedImages)
    return groupedImages
  }

  const runFactCheck = async (index, messageRef, messageContent) => {
    // const content = `事実確認対象文章：${messageContent}`
    // console.log('runFactCheck実行')
    // setIsFactCheckRunning(true)
    // setFactCheckRunningIndex(index)
    // chatData[index].factCheckResult = 'ファクトチェックサポート機能を実行中です...'
    // setChatData([...chatData])
    // const controller = new AbortController()
    // // const URL = 'http://localhost:8080/agent_create_thread_and_run'
    // const URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/agent_create_thread_and_run'
    // const res = await fetch(URL, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({ role: 'user', content })
    // })
    // const reader = res.body.getReader()
    // const decoder = new TextDecoder('utf-8')
    // let count = 0
    // let jsons = []
    // let message = ''
    // let source = ''
    // let assistantChatMessage = {}
    // const read = async (missingJson = '') => {
    //   const { done, value } = await reader.read()
    //   if (done) {
    //     setDisableSpeaker(false)
    //     setIsGenerating(false)
    //     return reader.releaseLock()
    //   }
    //   const chunk = decoder.decode(value, { stream: true })
    //   const trimData = chunk.trim()
    //   const jsonStrings = trimData.split(/(?={"data":)/)
    //   if (trimData === '' || trimData === '[DONE]') {
    //     jsons = []
    //   } else {
    //     // 各JSON文字列を個別にパースして処理
    //     jsons = jsonStrings.map((jsonString) => {
    //       try {
    //         const parsedJson = JSON.parse(missingJson + jsonString)
    //         missingJson = ''
    //         // 必要に応じてparsedJsonを操作
    //         return parsedJson
    //       } catch (error) {
    //         console.error('JSONパースエラー:', error, '問題のある文字列:', jsonString)
    //         missingJson = jsonString
    //         return undefined
    //       }
    //     })
    //   }
    //   const messageTime = new Date().getTime()
    //   for (let json of jsons) {
    //     if (json && (json.event === 'thread.run.failed' || json.event === 'thread.run.step.failed')) {
    //       chatData[index].factCheckResult =
    //         'ファクトチェックサポート機能でエラーが発生しました。少し時間を空けてからお試しください'
    //       setChatData([...chatData])
    //       return reader.releaseLock()
    //     }
    //     // if (json && json.event === 'thread.created') {
    //     //   const currentUrl = new URL(window.location) // 修正: `href`を使用
    //     //   window.history.pushState({}, '', currentUrl)
    //     // }
    //     if (json && json.event === 'thread.message.delta') {
    //       if (count === 0) {
    //         chatData[index].factCheckResult = ''
    //         setChatData([...chatData])
    //       }
    //       if (json?.data?.delta?.content?.[0]?.text?.annotations !== undefined) {
    //         console.log('json.data.delta.content[0].text.annotations', json.data.delta.content[0].text.annotations)
    //         json.data.delta.content[0].text.annotations.map((annotation) => {
    //           console.log('annotation', annotation)
    //           source += `・<a href="${annotation.url_citation.url}" target="_blank">${annotation.url_citation.title}</a>\n\n`
    //         })
    //       } else {
    //         message += json.data.delta.content[0].text.value
    //         assistantChatMessage = {
    //           role: 'assistant',
    //           content: message,
    //           messageTime,
    //           characterCount: message.length
    //         }
    //         chatData[index].factCheckResult = message
    //         setChatData([...chatData])
    //         count = count + 1
    //         setIsActiveAvator(count)
    //       }
    //     }
    //   }
    //   return read(missingJson)
    // }
    // await read()
    // console.log('source', source)
    // if (source !== '') {
    //   const messageTime = new Date().getTime()
    //   message += '\n\n\n\n[情報源]\n\n' + source
    //   const assistantChatMessage = {
    //     role: 'assistant',
    //     content: message,
    //     messageTime,
    //     characterCount: message.length
    //   }
    //   chatData[index].factCheckResult = message
    //   setChatData([...chatData])
    //   count = count + 1
    //   setIsActiveAvator(count)
    // }
    // setIsFactCheckRunning(false)
    // setFactCheckRunningIndex(null)
    // await updateDoc(messageRef, {
    //   factCheckResult: chatData[index].factCheckResult
    // })
    // return

    setIsFactCheckRunning(true)
    setFactCheckRunningIndex(index)
    chatData[index].factCheckResult = 'ファクトチェックサポート機能を実行中です...'
    setChatData([...chatData])
    const controller = new AbortController()
    let reader, decoder
    let count = 0
    let message = '\n\n'
    // const content = `
    //     以下の事実確認対象文章に対して、官公庁のサイトや信頼度の高いサイトを中心に検索して事実確認を行ってください。事実確認調査は、「事実の可能性が高い」「まだ判断できないのでさらなるリサーチが必要」「事実ではない可能性が高い」の三段階で、表示してください。出力形式は以下のテンプレートに従ってください。
    // 事実確認対象文章：
    // ${messageContent}
    // テンプレート:
    // ■ ファクトチェックサポート（※この機能は、絶対的な真偽を保証するものではなので、人間であるあなたが判断するための材料としてお使いください）\n\n
    // ・事実確認調査： // 一言で結果を記載\n\n
    // ・結果の理由： // 最大300文字以内で理由を記載\n\n
    //     `

    //     const content = `
    //     以下の事実確認対象文章に対して、以下のステップで事実確認を行ってください。
    // ステップ１：官公庁のサイトや信頼度の高いサイトを中心に検索してください
    // ステップ２：ステップ１で検索した内容を確認し、表示してください。事実確認調査は、「事実の可能性が高い」「まだ判断できないのでさらなるリサーチが必要」「事実ではない可能性が高い」の三段階で、表示してください。出力形式は以下のテンプレートに従ってください。
    //     事実確認対象文章：
    //     ${messageContent}

    // テンプレート:
    //     ■ ファクトチェックサポート（※この機能は、絶対的な真偽を保証するものではなので、人間であるあなたが判断するための材料としてお使いください）\n\n
    //     ・事実確認調査： // 一言で結果を記載\n\n
    //     ・結果の理由： // 最大300文字以内で理由を記載\n\n`

    const content = `
以下の事実確認対象文章に対して、以下のステップで事実確認を行ってください。
ステップ１：事実確認対象文章について、検索して内容を確認してください。
ステップ２：ステップ１で検索した内容を確認して表示してください。事実確認調査は、「事実の可能性が高い」「まだ判断できないのでさらなるリサーチが必要」「事実ではない可能性が高い」の三段階で、表示してください。出力形式は以下のテンプレートに従ってください。
    事実確認対象文章：
    ${messageContent}

テンプレート:
    ■ ファクトチェックサポート（※この機能は、絶対的な真偽を保証するものではなので、人間であるあなたが判断するための材料としてお使いください）\n\n
    ・事実確認調査： // 一言で結果を記載\n\n
    ・結果の理由： // 最大300文字以内で理由を記載\n\n`
    ;[reader, decoder] = await getVertexAIGemeniStreamingMessageReaderAndDecoder({
      model: 'gemini-1.5-pro-002',
      messages: [{ role: 'user', content }],
      controller
    })
    chatData[index].factCheckResult = ''
    setChatData([...chatData])
    const read = async (missingJson = '') => {
      const { done, value } = await reader.read()
      if (done) {
        setDisableSpeaker(false)
        setIsGenerating(false)
        return reader.releaseLock()
      }
      const chunk = decoder.decode(value, { stream: true })
      const jsons = chunk
        .split('data:')
        .map((data) => {
          const trimData = data.trim()
          if (trimData === '' || trimData === '[DONE]') return undefined
          try {
            const jsonObj = JSON.parse(missingJson + trimData)
            missingJson = ''
            return jsonObj
          } catch (e) {
            missingJson = trimData
            return undefined
          }
        })
        .filter((data) => data)
      const messageTime = new Date().getTime()
      ///////////////////////////
      //  Azure OpenAI Service の Stream 出力をスムーズに見せかけるトリック (see: https://qiita.com/nohanaga/items/eea68e0b7a0f417c5276)
      for (let test of jsons) {
        await new Promise((resolve) => {
          setTimeout(() => {
            if ((test.candidates && test.candidates.length !== 0) || test.candidates !== undefined) {
              if (test.candidates && test.candidates[0].content !== undefined) {
                message += test.candidates[0].content.parts[0].text
                const assistantChatMessage = {
                  role: 'assistant',
                  content: message,
                  messageTime,
                  characterCount: message.length
                }
                chatData[index].factCheckResult = message
                setChatData([...chatData])
                count = count + 1
                setIsActiveAvator(count)
              }
            }
            if (test.candidates && test.candidates[0].groundingMetadata !== undefined) {
              console.log('groundingMetadata', test.candidates[0].groundingMetadata)
              let source = ''
              if (test.candidates && test.candidates[0].groundingMetadata.groundingChunks !== undefined) {
                test.candidates[0].groundingMetadata.groundingChunks.map((groundingChunk) => {
                  console.log('groundingChunk.web.title', groundingChunk.web.title)
                  console.log('groundingChunk.web.uri', groundingChunk.web.uri)
                  source += `・<a href="${groundingChunk.web.uri}" target="_blank">${groundingChunk.web.title}</a>\n\n`
                })
              }
              if (source !== '') {
                message += '\n\n\n\n[情報源]\n\n' + source
                const assistantChatMessage = {
                  role: 'assistant',
                  content: message,
                  messageTime,
                  characterCount: message.length
                }
                chatData[index].factCheckResult = message
                setChatData([...chatData])
                count = count + 1
                setIsActiveAvator(count)
              }
            }
            resolve(null)
          }, 33)
        })
      }
      return read(missingJson)
    }
    await read()
    setIsFactCheckRunning(false)
    setFactCheckRunningIndex(null)
    await updateDoc(messageRef, {
      factCheckResult: chatData[index].factCheckResult
    })
  }

  return (
    <>
      {_start === true || _startButton === false || readOnly === true ? (
        <>
          {generatingImage ? <LoadingGrid text="ローディング中..." /> : <></>}
          <>
            {isLoading ? (
              <LoadingGrid text="ローディング中" />
            ) : (
              <div id={newConversationId ? newConversationId : conversationId}>
                {startover && (
                  <div
                    id="start-over"
                    className={showheader === 'true' ? styles['your-container-class'] : styles['your-container-class2']}
                  >
                    <button className={styles['start-over-button']} onClick={(e) => startOverHandler(e)}>
                      {translate('restartConversation')}
                    </button>
                  </div>
                )}
                {isLargeIcon && (
                  <div
                    className={showheader === 'true' || showheader === true ? styles['chat3'] : styles['chat4']}
                    id="chat-container1"
                    ref={avatorContainerRef}
                    style={determineHalfStyle()}
                  >
                    <Avator
                      imageEnlargement={true}
                      isActiveAvator={isActiveAvator}
                      avator_images={avatorImages}
                      isLargeIcon={isLargeIcon}
                      largeIconAvatorWidth={largeIconAvatorWidth}
                      isGenerating={isGenerating}
                    />
                    {isLargeIcon && (
                      <MenuIcon
                        conversationId={newConversationId ? newConversationId : conversationId}
                        className={styles['menu-icon']}
                        path={window.location.pathname}
                        type={showheader !== 'false' ? 'chat-screen' : 'chat-screen-without-header'}
                        onButtonClick={openModalForConversationSubmission}
                        anchorEl={anchorEl}
                        setAnchorEl={setAnchorEl}
                        links={state ? state.links ?? [] : conversation ? conversation.links ?? [] : []}
                      />
                    )}
                  </div>
                )}

                <div
                  className={showheader === 'true' || showheader === true ? styles['chat'] : styles['chat2']}
                  id="chat-container2"
                  ref={containerRef}
                  style={isLargeIcon ? determineHalfStyle() : determineStyle()}
                >
                  {isLargeIcon !== true && (
                    <MenuIcon
                      conversationId={newConversationId ? newConversationId : conversationId}
                      className={styles['menu-icon']}
                      type={showheader !== 'false' ? 'chat-screen' : 'chat-screen-without-header'}
                      onButtonClick={openModalForConversationSubmission}
                      anchorEl={anchorEl}
                      setAnchorEl={setAnchorEl}
                      links={state ? state.links ?? [] : conversation ? conversation.links ?? [] : []}
                    />
                  )}
                  {chatData
                    .filter((item) => item.bubbleForSystem === true || !item.hide) // hide プロパティが true の場合はフィルタリング
                    .map((item, index, arr) => {
                      return (
                        <React.Fragment key={index}>
                          {item.role === 'system' || item.bubbleForSystem === true ? (
                            (item.userInput === true &&
                              displayInputContents !== false &&
                              currentPath !== '/thread_list') ||
                            (item.userInput === true && currentPath === '/thread_list') ? (
                              <ChatBubbleForSystem
                                setChatData={setChatData}
                                key={index}
                                userId={userId}
                                conversationId={conversationId ? conversationId : newConversationId}
                                role={item.role}
                                subject={item.subject}
                                question={item.question}
                                answer={item.answer}
                                userInputValue={item.userInputValue}
                                messageDocRef={item.ref}
                                messageTime={item.messageTime}
                                isGenerating={isGenerating}
                                prompt={promptData}
                                onButtonClick={openModalForSubmission}
                                readOnly={readOnly}
                                // hiddenMessages={nextItem ? nextItem : undefined}
                                // hiddenMessages={hiddenMessages ? hiddenMessages : undefined}
                                onUserInputChange={handleUserInputChange}
                                sentenceWordReplacementList={sentenceWordReplacementList}
                                onSentenceWordReplacementListChange={setSentenceWordReplacementList}
                              />
                            ) : (
                              <></>
                            )
                          ) : (
                            <div>
                              <ChatBubble
                                index={index}
                                isGenerating={isGenerating}
                                lastIndex={index === chatData.length - 1}
                                isLastChat={index === arr.length - 1}
                                chatLength={chatData.length}
                                isActiveAvator={isActiveAvator}
                                role={item.role}
                                messageText={Array.isArray(item.content) ? item.content[0].text : item.content}
                                displayMessage={item.displayMessage}
                                useDisplayMessage={
                                  state?.useDisplayMessage
                                    ? state.useDisplayMessage
                                    : conversation?.useDisplayMessage
                                    ? conversation.useDisplayMessage
                                    : false
                                }
                                messagePictures={
                                  Array.isArray(item.content)
                                    ? item.content
                                        .filter((contentItem) => contentItem.type === 'image_url')
                                        .map((imageContent) => imageContent.image_url.url)
                                    : []
                                }
                                docFiles={item.docFiles ?? []}
                                avator_images={avatorImages}
                                disableSpeaker={disableSpeaker}
                                isLargeIcon={isLargeIcon}
                                id={`chat-bubble-${index}`}
                                onVolumeUp={() =>
                                  playTextSound(
                                    Array.isArray(item.content) ? item.content[0].text : item.content,
                                    '',
                                    true,
                                    index
                                  )
                                }
                                onVolumeOff={() => stopPlaying()}
                                playingIndex={playingIndex}
                                onPlaying={onPlaying}
                                onButtonClick={() => {
                                  openModalForSubmission(item)
                                }}
                                messageTime={item.messageTime}
                                isAudioGenerating={isAudioGenerating}
                                runFactCheck={() =>
                                  runFactCheck(
                                    index,
                                    item.ref,
                                    Array.isArray(item.content) ? item.content[0].text : item.content
                                  )
                                }
                                factCheckResult={item.factCheckResult}
                                isFactCheckRunning={isFactCheckRunning}
                                factCheckRunningIndex={factCheckRunningIndex}
                              />
                            </div>
                          )}
                        </React.Fragment>
                      )
                    })}
                </div>
              </div>
            )}
          </>
          {readOnly === false && (
            <div
              className={styles['user-input']}
              style={
                displayFooter === true
                  ? { bottom: `calc(100vh - ${chatScreenBottom}px)`, width: `calc(${userInputWidth} - 2vh)` }
                  : { bottom: `0`, width: `calc(${userInputWidth} - 2vh)` }
              }
            >
              <FormControl className={styles['form-control']}>
                {isLoading ? (
                  <></>
                ) : (
                  <div className={styles['reply-container']}>
                    <div className={styles['reply']} ref={replyRef} id="reply">
                      {responseOptions.map((item, index) => (
                        <div className={styles['option']} key={index}>
                          <button
                            className={isGenerating ? styles['option-generating'] : styles['option']}
                            onClick={() => onTextInput(item.content, item.option)}
                            disabled={isGenerating}
                          >
                            {item.option}
                          </button>
                        </div>
                      ))}
                    </div>
                    <div
                      className={`${styles['arrow']} ${styles['arrow--left']} ${
                        !replyOverflowing ? styles['arrow--hidden'] : ''
                      }`}
                      onClick={() => {
                        scroll('left')
                      }}
                    >
                      <KeyboardDoubleArrowLeftIcon />
                    </div>
                    <div
                      className={`${styles['arrow']} ${styles['arrow--right']} ${
                        !replyOverflowing ? styles['arrow--hidden'] : ''
                      }`}
                      onClick={() => {
                        scroll('right')
                      }}
                    >
                      <KeyboardDoubleArrowRightIcon />
                    </div>
                  </div>
                )}

                <Textarea
                  disabled={isLoading}
                  autoFocus={true}
                  className={styles['mui-textarea']}
                  onChange={handleInputChange}
                  value={chatInput}
                  placeholder={translate('tapToReply')}
                  minRows={1}
                  onKeyDown={handleKeyDown}
                  onPaste={handlePaste}
                  startDecorator={
                    <>
                      {previewUrls?.length !== 0 && (
                        <div>
                          {previewUrls.map((url, index) => (
                            <Box
                              sx={{ position: 'relative', display: 'inline-block' }}
                              onMouseEnter={() => setHoveredPreviewIndexNumber(index)}
                              onMouseLeave={() => setHoveredPreviewIndexNumber(-1)}
                              key={url} // 一意なBlob URLをkeyとして使用
                            >
                              <img
                                src={url}
                                alt="Image preview"
                                style={{ maxHeight: 60, margin: 2, borderRadius: 6 }}
                              />
                              {hoveredPreviewIndexNumber === index && (
                                <IconButton
                                  className="remove-icon"
                                  size="small"
                                  sx={{
                                    position: 'absolute',
                                    right: 0,
                                    top: 0,
                                    color: 'primary.main',
                                    backgroundColor: 'background.paper',
                                    '&:hover': {
                                      backgroundColor: 'grey.300'
                                    }
                                  }}
                                  onClick={() => removePreview(index, 'image')}
                                >
                                  <CancelIcon fontSize="small" />
                                </IconButton>
                              )}
                            </Box>
                          ))}
                        </div>
                      )}
                      {files.documentFiles?.length > 0 && (
                        <div>
                          {files.documentFiles.map((file, index) => (
                            <Box
                              sx={{ position: 'relative', display: 'flex' }}
                              onMouseEnter={() => setHoveredDocumentFileIndex(index)}
                              onMouseLeave={() => setHoveredDocumentFileIndex(-1)}
                              key={`${file.name ?? 'name'}${index}`}
                            >
                              <TextSnippetIcon />
                              <div>{(file.name ?? '不明なファイル名') + '(試験運用中)'}</div>
                              {hoveredDocumentFileIndex === index && (
                                <IconButton
                                  className="remove-icon"
                                  size="small"
                                  sx={{
                                    position: 'absolute',
                                    right: 0,
                                    top: 0,
                                    color: 'primary.main',
                                    backgroundColor: 'background.paper',
                                    '&:hover': {
                                      backgroundColor: 'grey.300'
                                    }
                                  }}
                                  onClick={() => removePreview(index, 'document')}
                                >
                                  <CancelIcon fontSize="small" />
                                </IconButton>
                              )}
                            </Box>
                          ))}
                        </div>
                      )}
                    </>
                  }
                  endDecorator={
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 'var(--Textarea-paddingBlock)',
                        pt: 'var(--Textarea-paddingBlock)',
                        borderTop: '1px solid',
                        borderColor: 'divider',
                        flex: 'auto'
                      }}
                    >
                      <div className={styles.text2imageContainer}>
                        <label className={styles[text2imageLabelClassName]}>
                          <input type="file" onChange={onChangeImage} />
                          <div className={styles.text2image}>{translate('imageToText')}</div>
                        </label>
                        {/* <label className={styles[text2imageLabelClassName]}>
                          <div
                            className={styles.text2image}
                            onClick={
                              false
                                ? () => getImageFromGPT()
                                : () =>
                                    alert(
                                      '画像生成機能のメンテナンスを行っており、現在ご利用いただけません。ご不便をおかけして申し訳ありませんが、もうしばらくお待ちください。'
                                    )
                            }
                          >
                            画像生成
                          </div>
                        </label> */}
                      </div>

                      <div className={styles['button-area']}>
                        {_gpt_model
                          .filter((model) => model.availableVision === true)
                          .map((model) => model.value)
                          .includes(model) &&
                          !_useAssistantApi && (
                            <>
                              <input
                                ref={fileInputRef}
                                accept="image/*, .xls, .xlsx"
                                style={{ display: 'none' }}
                                id="icon-button-file"
                                type="file"
                                multiple // 複数選択を許可
                                onChange={handleFilesChange}
                              />
                              <label className={styles.attach} htmlFor="icon-button-file">
                                <IconButton
                                  className={styles.attachButton}
                                  // color="primary"
                                  aria-label="upload picture"
                                  component="span"
                                >
                                  <AttachFileIcon className={styles.attachIcon} />
                                </IconButton>
                              </label>
                            </>
                          )}
                        {/* <CustomWidthTooltip
                          title={`${JSON.parse(selectedLanguage).japaneseName}`}
                          arrow
                          enterTouchDelay={100}
                          open={true}
                        > */}
                        <Select
                          className={styles.select}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={selectedLanguage}
                          onChange={changeLanguage}
                        >
                          {languageList2.map((language) => (
                            <MenuItem
                              key={JSON.stringify(language)}
                              value={JSON.stringify(language)}
                              className={styles.menuItem}
                              sx={{ fontSize: 12 }}
                            >
                              {language.shortenName}
                            </MenuItem>
                          ))}
                        </Select>
                        {/* </CustomWidthTooltip> */}
                        <Button
                          className={isMute ? styles['send-deactive'] : styles[sendActiveClassName]}
                          sx={{ ml: 'auto', paddingInline: '2.5%', width: '10%', minWidth: '45px' }}
                          onClick={() => changeMute()}
                        >
                          {isMute ? <VolumeOffIcon /> : <VolumeUpIcon />}
                        </Button>
                        <Button
                          className={isLoading || islistening ? styles['send-deactive'] : styles[sendActiveClassName]}
                          sx={{ ml: 'auto', paddingInline: '2.5%', width: '10%', minWidth: '45px' }}
                          onClick={isLoading || islistening ? () => resetListening() : onVoiceInput}
                        >
                          {islistening ? (
                            <Bars
                              height="24"
                              width="24"
                              className="voice-icon"
                              color="#ffff"
                              ariaLabel="audio-loading"
                              wrapperStyle={{}}
                              wrapperClass="wrapper-class"
                              visible={true}
                            />
                          ) : (
                            <KeyboardVoiceIcon className="voice-icon" />
                          )}
                        </Button>
                        {isGenerating ? (
                          <Button
                            className={styles[sendActiveClassName]}
                            sx={{ ml: 'auto', paddingInline: '2.5%', width: '10%', minWidth: '45px' }}
                            onClick={() => {
                              handleCancelStream()
                            }}
                          >
                            <StopCircleIcon />
                          </Button>
                        ) : (
                          <Button
                            className={
                              islistening || isLoading || !chatInput
                                ? styles['send-deactive']
                                : styles[sendActiveClassName]
                            }
                            sx={{ ml: 'auto', paddingInline: '2.5%', width: '10%', minWidth: '45px' }}
                            // onClick={islistening || isLoading || !chatInput ? () => {} : onTextInput}
                            onClick={() => {
                              if (!islistening && !isLoading && chatInput) {
                                onTextInput() // ここで引数を渡さないようにしています
                              }
                            }}
                          >
                            <SendIcon />
                          </Button>
                        )}
                      </div>
                    </Box>
                  }
                />
                <p variant="caption" style={{ bottom: '46px' }} className={styles['textarea-length']}>
                  {chatInput.replace(/\n/g, '').length} {translate('wordCount')}
                </p>
              </FormControl>
            </div>
          )}

          {isModalOpenForSubmission && (
            <div className={styles.modalWrapperForSubmission}>
              <div className={styles.overlay}></div>
              <div ref={modalRef} className={styles.modal}>
                <h3>提出ボックス一覧</h3>

                <div className={styles['modes']}>
                  {submissionBoxes.map((item, index) => {
                    return (
                      <div className={styles.mode} key={index}>
                        <div className={styles.title}>
                          <h4 className={styles.title}>{item.submission_box_title}</h4>
                        </div>
                        <div className={styles.cardBottomContainer}>
                          <div className={styles.description}>{''}</div>
                          <div onClick={() => submissionConversation(item)} className={styles.start}>
                            提出する
                          </div>
                        </div>
                      </div>
                    )
                  })}
                  {submissionBoxes.length === 0 && <p>提出ボックスがありません</p>}
                </div>
                <button className={styles['start']} onClick={closeModalForSubmission}>
                  <p className={styles['sub-button-text']}>閉じる</p>
                </button>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          {generatingImage ? <LoadingGrid text="ローディング中..." /> : <></>}
          <div className={styles['start-button-container']}>
            <button
              className={generatingImage ? styles['round-button-disable'] : styles['round-button']}
              onClick={() => startHandler()}
            >
              <p className={styles['button-text']}>{translate('confirmationForUsage')}</p>
              <b className={styles['button-text']}>{translate('startChat')}</b>
            </button>
            <div className={styles['start-explanation']}>
              {customGuide != null ? (
                <p className={styles['explanation']}>{customGuide}</p>
              ) : (
                <>
                  <p className={styles['explanation']}>
                    ■
                    <ruby>
                      生徒<rt>せいと</rt>
                    </ruby>
                    <ruby>
                      向<rt>む</rt>
                    </ruby>
                    けガイド
                    <br />
                    <ruby>
                      初<rt>はじ</rt>
                    </ruby>
                    めての
                    <ruby>
                      人<rt>ひと</rt>
                    </ruby>
                    は
                    <a target="_blank" rel="noreferrer" href="https://mingaku.net/guide/schoolai1">
                      このガイド
                    </a>
                    を
                    <ruby>
                      見<rt>み</rt>
                    </ruby>
                    てください
                    <br />
                    <br />■
                    <ruby>
                      使<rt>つか</rt>
                    </ruby>
                    い
                    <ruby>
                      方<rt>かた</rt>
                    </ruby>
                    の
                    <ruby>
                      注意<rt>ちゅうい</rt>
                    </ruby>
                    <ruby>
                      点<rt>てん</rt>
                    </ruby>
                    <br />① AIの
                    <ruby>
                      答<rt>こた</rt>
                    </ruby>
                    えが
                    <ruby>
                      正<rt>ただ</rt>
                    </ruby>
                    しいか
                    <ruby>
                      調<rt>しら</rt>
                    </ruby>
                    べる
                    <br />
                    AIの
                    <ruby>
                      出<rt>だ</rt>
                    </ruby>
                    す
                    <ruby>
                      回答<rt>かいとう</rt>
                    </ruby>
                    が
                    <ruby>
                      必<rt>かなら</rt>
                    </ruby>
                    ずしも
                    <ruby>
                      正<rt>ただ</rt>
                    </ruby>
                    しいとは
                    <ruby>
                      限<rt>かぎ</rt>
                    </ruby>
                    りません。
                    <ruby>
                      重要<rt>じゅうよう</rt>
                    </ruby>
                    な
                    <ruby>
                      情報<rt>じょうほう</rt>
                    </ruby>
                    は
                    <ruby>
                      確認<rt>かくにん</rt>
                    </ruby>
                    するようにしてください。
                    <br />
                    <br />②
                    <ruby>
                      個人<rt>こじん</rt>
                    </ruby>
                    <ruby>
                      情報<rt>じょうほう</rt>
                    </ruby>
                    は
                    <ruby>
                      入<rt>い</rt>
                    </ruby>
                    れない
                    <br />
                    <ruby>
                      名前<rt>なまえ</rt>
                    </ruby>
                    や
                    <ruby>
                      住所<rt>じゅうしょ</rt>
                    </ruby>
                    はとても
                    <ruby>
                      大切<rt>たいせつ</rt>
                    </ruby>
                    な
                    <ruby>
                      情報<rt>じょうほう</rt>
                    </ruby>
                    です。
                    <ruby>
                      入力<rt>にゅうりょく</rt>
                    </ruby>
                    しないようにしましょう。
                    <br />
                    <br />③ AIが
                    <ruby>
                      作<rt>つく</rt>
                    </ruby>
                    ったものをそのまま
                    <ruby>
                      使<rt>つか</rt>
                    </ruby>
                    わない
                    <br />
                    AIの
                    <ruby>
                      答<rt>こた</rt>
                    </ruby>
                    えをそのまま
                    <ruby>
                      使<rt>つか</rt>
                    </ruby>
                    うと、
                    <ruby>
                      勉強<rt>べんきょう</rt>
                    </ruby>
                    になりません。
                    <br />
                    AIの
                    <ruby>
                      答<rt>こた</rt>
                    </ruby>
                    えは
                    <ruby>
                      参考<rt>さんこう</rt>
                    </ruby>
                    にして、
                    <ruby>
                      自分<rt>じぶん</rt>
                    </ruby>
                    で
                    <ruby>
                      考<rt>かんが</rt>
                    </ruby>
                    えることが
                    <ruby>
                      大切<rt>たいせつ</rt>
                    </ruby>
                    です。
                    <br />
                    ※わからないことがあったら、
                    <ruby>
                      先生<rt>せんせい</rt>
                    </ruby>
                    や
                    <ruby>
                      保護者<rt>ほごしゃ</rt>
                    </ruby>
                    の
                    <ruby>
                      人<rt>ひと</rt>
                    </ruby>
                    に
                    <ruby>
                      聞<rt>き</rt>
                    </ruby>
                    いてみてください！
                    <br />
                    <br />④
                    <ruby>
                      先生<rt>せんせい</rt>
                    </ruby>
                    または
                    <ruby>
                      保護者<rt>ほごしゃ</rt>
                    </ruby>
                    の
                    <ruby>
                      方<rt>かた</rt>
                    </ruby>
                    の
                    <ruby>
                      許可<rt>きょか</rt>
                    </ruby>
                    をもらってから
                    <ruby>
                      使<rt>つか</rt>
                    </ruby>
                    う
                    <br />
                    <ruby>
                      大人<rt>おとな</rt>
                    </ruby>
                    の
                    <ruby>
                      人<rt>ひと</rt>
                    </ruby>
                    に
                    <ruby>
                      確認<rt>かくにん</rt>
                    </ruby>
                    してから、
                    <ruby>
                      正<rt>ただ</rt>
                    </ruby>
                    しく
                    <ruby>
                      使<rt>つか</rt>
                    </ruby>
                    うようにしましょう。
                    <br />（
                    <ruby>
                      保護者<rt>ほごしゃ</rt>
                    </ruby>
                    の
                    <ruby>
                      人<rt>ひと</rt>
                    </ruby>
                    に「保護者の
                    <ruby>
                      方<rt>かた</rt>
                    </ruby>
                    へ」を
                    <ruby>
                      読<rt>よ</rt>
                    </ruby>
                    んでもらってください）
                    <br />
                    <br />
                    ■　保護者の方へ
                    <br />
                    お子様が利用される前に、以下の内容をご確認ください。
                  </p>
                  <button className={styles['buttonForParent']} onClick={openModal}>
                    <p className={styles['sub-button-text']}>保護者の方へ</p>
                  </button>
                </>
              )}
            </div>
          </div>

          {isModalOpen && (
            <div className={styles.modalWrapper}>
              <div className={styles.overlay}></div>
              <div className={styles.modal}>
                <div className="modal">
                  <p>※表示に時間が掛かるときがあります。</p>
                  <iframe
                    className={styles.iframe}
                    title="保護者の方向けの利用規約"
                    src="https://docs.google.com/file/d/1NJmhQwBq7ysM48Y_lfPMpf2Orawn0JUA/preview?usp=drivesdk"
                  ></iframe>
                </div>
                <button className={styles['close-button']} onClick={closeModal}>
                  <p className={styles['sub-button-text']}>閉じる</p>
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </>
  )
}
export default ChatScreen
